window.theme = window.theme || {}, theme.bp = {}, theme.bp.smallUp = 769, theme.bp.small = theme.bp.smallUp - 1, theme.config = {
        bpSmall: !1,
        hasSessionStorage: !0,
        hasLocalStorage: !0,
        mediaQuerySmall: "screen and (max-width: " + theme.bp.small + "px)",
        mediaQuerySmallUp: "screen and (min-width: " + theme.bp.smallUp + "px)",
        youTubeReady: !1,
        vimeoReady: !1,
        vimeoLoading: !1,
        isTouch: !!("ontouchstart" in window || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints),
        isIpad: /ipad/.test(window.navigator.userAgent.toLowerCase()) || "MacIntel" === window.navigator.platform && 1 < window.navigator.maxTouchPoints,
        stickyHeader: !1,
        recentlyViewed: [],
        rtl: "rtl" == document.documentElement.getAttribute("dir")
    }, theme.recentlyViewed = {
        recent: {},
        productInfo: {}
    }, theme.config.isIpad && (document.documentElement.className += " js-ipad"), console && console.log && console.log("Impulse theme (" + theme.settings.themeVersion + ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"), window.lazySizesConfig = window.lazySizesConfig || {}, lazySizesConfig.expFactor = 4,
    function(f) {
        var h, u, p, e, m, n, o, a, d, l, t, i, s, r, c, g, y, v, b, w, S, _, C, k, $, I, T, V, P, x, O, D, M, L, A, E, F, j, B, R, H, U, z, N, q, Q, Y, J, G, W, K, X, Z, ee, te, ie, ne, oe, ae, se, re, ce, de, le, he, ue, pe, me, fe, ge, ye, ve, be, we, Se, _e, Ce, ke, $e, Ie, Te, Ve, Pe, xe, Oe, De, Me, Le, Ae, Ee, Fe, je, Be, Re, He, Ue, ze, Ne, qe, Qe, f = jQuery = f;

        function Ye(e) {
            this.$container = e.$container, this.variants = e.variants, this.singleOptionSelector = e.singleOptionSelector, this.originalSelectorId = e.originalSelectorId, this.enableHistoryState = e.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), f(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
        }

        function Je(e, t, i) {
            var n = {
                close: ".js-modal-close",
                open: ".js-modal-open-" + t,
                openClass: "modal--is-active",
                closingClass: "modal--is-closing",
                bodyOpenClass: "modal-open",
                bodyOpenSolidClass: "modal-open--solid",
                bodyClosingClass: "modal-closing",
                closeOffContentClick: !0
            };
            if (this.id = e, this.$modal = f("#" + e), !this.$modal.length) return !1;
            this.nodes = {
                $parent: f("html").add("body"),
                $modalContent: this.$modal.find(".modal__inner")
            }, this.config = f.extend(n, i), this.modalIsOpen = !1, this.$focusOnOpen = this.config.focusOnOpen ? f(this.config.focusOnOpen) : this.$modal, this.isSolid = this.config.solid, this.init()
        }

        function Ge(e, t, i) {
            if (this.config = {
                    id: e,
                    close: ".js-drawer-close",
                    open: ".js-drawer-open-" + t,
                    openClass: "js-drawer-open",
                    closingClass: "js-drawer-closing",
                    activeDrawer: "drawer--is-open",
                    namespace: ".drawer-" + t
                }, this.$nodes = {
                    parent: f(document.documentElement).add("body"),
                    page: f("#MainContent")
                }, this.$drawer = f("#" + e), !this.$drawer.length) return !1;
            this.isOpen = !1, this.ignoreScrollLock = i, this.init()
        }

        function We(e, t) {
            this.$wrapper = e, this.$input = e.find(n), this.$plus = e.find(o), this.$minus = e.find(a), this.minValue = this.$input.attr("min") || 1;
            var i = {
                namespace: null,
                key: this.$input.data("id")
            };
            this.options = f.extend(i, t), this.initEventListeners()
        }

        function Ke() {
            this.status = {
                loaded: !1,
                loading: !1
            }, this.drawer = new theme.Drawers("CartDrawer", "cart");
            var e = f(t).html();
            this.template = Handlebars.compile(e), theme.cart.getCart().then(this.buildCart.bind(this)), document.addEventListener("cart:build", function() {
                theme.cart.getCart().then(this.buildCart.bind(this))
            }.bind(this)), this.initEventListeners()
        }

        function Xe(e) {
            this.$form = e, this.$addToCart = this.$form.find(".add-to-cart"), this.$form.length && this.$form.on("submit", this.addItemFromForm.bind(this))
        }

        function Ze(e, t, i, n) {
            var o;
            e.removeClass(g.hide).prepareTransition().css("height", t).toggleClass(g.open, !i), !i && n ? (o = e, window.setTimeout(function() {
                o.css("height", "auto"), v = !1
            }, 350)) : v = !1
        }

        function et() {
            f(document.activeElement).trigger("blur"), _.removeClass("js-drawer-open--search").off(I.namespace), f(k.searchContainer).removeClass("is-active"), theme.a11y.removeTrapFocus({
                $container: f(k.searchContainer),
                namespace: "header_search"
            }), theme.a11y.unlockMobileScrolling(I.namespace), C.off("click" + I.namespace), _.off("keyup" + I.namespace)
        }

        function tt() {
            theme.config.stickyHeader = function() {
                var t = 0;
                if (f(k.megamenu).each(function() {
                        var e = f(this).outerHeight();
                        t < e && (t = e)
                    }), window.innerHeight < t + 120) return !1;
                return !0
            }(), theme.config.stickyHeader ? (I.forceStopSticky = !1, function() {
                I.stickyInitialized || (_.addClass($.stickyBodyClass), S.wrap('<div class="site-header-sticky"></div>'), it(), setTimeout(function() {
                    it()
                }, 200), b.on("resize" + I.namespace, f.debounce(50, it)), b.on("scroll" + I.namespace, f.throttle(15, nt)));
                I.stickyInitialized = !0
            }()) : I.forceStopSticky = !0
        }

        function it() {
            var e = S.outerHeight(!0);
            f(".site-header-sticky").css("height", e);
            f(".grid__item--sidebar").length && f(".grid__item--sidebar").css("top", e + 10)
        }

        function nt() {
            if (!I.forceStopSticky) {
                var e = b.scrollTop();
                if (150 < e) {
                    if (I.stickyActive) return;
                    I.stickyActive = !0, S.addClass(I.stickyClass), I.wrapperOverlayed && w.removeClass(I.overlayedClass), setTimeout(function() {
                        S.addClass(I.openTransitionClass)
                    }, 100)
                } else {
                    if (!I.stickyActive) return;
                    I.stickyActive = !1, S.removeClass(I.openTransitionClass).removeClass(I.stickyClass), I.wrapperOverlayed && w.addClass(I.overlayedClass)
                }
                I.lastScroll = e
            }
        }

        function ot(e, t) {
            at(e) && e.slick("unslick"), e.slick(t)
        }

        function at(e) {
            return e.length && e.hasClass("slick-initialized")
        }

        function st() {
            f(A.wrapper).addClass("hide"), clearTimeout(O)
        }

        function rt() {
            f(A.form).trigger("submit")
        }

        function ct(e) {
            var t = f(this);
            e.preventDefault ? e.preventDefault() : e.returnValue = !1;
            var i = t.serializeArray().reduce(function(e, t) {
                return e[t.name] = t.value, e
            }, {});
            i.q && (i.q += "*");
            var n = f.param(i);
            return window.location.href = "/search?" + n, !1
        }

        function dt(e) {
            e.keyCode !== E.up_arrow && e.keyCode !== E.down_arrow && e.keyCode !== E.tab && function() {
                var e = f(A.input, A.form).val();
                if ("" === e) return st();
                var t = function(e) {
                    return "string" == typeof e ? e.trim().replace(/\ /g, "-").toLowerCase() : null
                }(e);
                clearTimeout(O), O = setTimeout(function() {
                    ! function(e) {
                        if (M) return;
                        if (D === e) return;
                        D = e, M = !0, jQuery.getJSON("/search/suggest.json", {
                            q: e,
                            resources: {
                                type: theme.settings.predictiveSearchType,
                                limit: 4,
                                options: {
                                    unavailable_products: "last",
                                    fields: "title,product_type,variants.title,vendor"
                                }
                            }
                        }).done(function(e) {
                            M = !1;
                            var t = {},
                                i = 0;
                            f(A.wrapper).removeClass("hide");
                            for (var n = Object.entries(e.resources.results), o = n.length - 1; 0 <= o; o--) {
                                var a = n[o],
                                    s = a[0],
                                    r = a[1];
                                switch (i += r.length, s) {
                                    case "products":
                                        t[s] = function(e) {
                                            for (var t = [], i = e.length - 1; 0 <= i; i--) {
                                                var n = e[i],
                                                    o = {
                                                        title: n.title,
                                                        url: n.url,
                                                        image: theme.Images.lazyloadImagePath(n.image),
                                                        vendor: n.vendor,
                                                        price: theme.Currency.formatMoney(n.price),
                                                        compare_price_max: theme.Currency.formatMoney(n.compare_at_price_max),
                                                        on_sale: parseInt(n.compare_at_price_max) > parseInt(n.price),
                                                        custom_label: function(e) {
                                                            if (!e.length) return !1;
                                                            for (var t = e.length - 1; 0 <= t; t--)
                                                                if (-1 !== e[t].indexOf("_label_")) return e[t].replace("_label_", "");
                                                            return !1
                                                        }(n.tags)
                                                    };
                                                t.push(o)
                                            }
                                            return t
                                        }(r);
                                        break;
                                    case "collections":
                                        t[s] = function(e) {
                                            for (var t = [], i = e.length - 1; 0 <= i; i--) {
                                                var n = e[i],
                                                    o = {
                                                        title: n.title,
                                                        url: n.url
                                                    };
                                                t.push(o)
                                            }
                                            return t
                                        }(r);
                                        break;
                                    default:
                                        t[s] = function(e) {
                                            for (var t = e.length - 1; 0 <= t; t--) {
                                                var i;
                                                e[t].image && (i = theme.Images.lazyloadImagePath(e[t].image), e[t].image = i)
                                            }
                                            return e
                                        }(r)
                                }
                            }
                            0 === i && st(), f(A.resultDiv).empty().append(resultTemplate(t))
                        })
                    }(t)
                }.bind(this), 500)
            }()
        }

        function lt(e) {
            var t = this.$container = f(e),
                i = this.sectionId = t.attr("data-section-id");
            this.namespace = ".recently-viewed" + i, f(F).length && (this.checkVisibility(), f(window).on("scroll" + this.namespace, f.throttle(200, this.checkVisibility.bind(this))))
        }

        function ht(e, t) {
            this.$container = f(e), this.namespace = t.namespace, this.$container.length && (t.desktopOnly ? this.desktopInit() : this.init(this.$container, t))
        }

        function ut(e) {
            this.$container = e, this.cache = {}, this._cacheSelectors(), this._connectOptions(), this._connectToggle(), this._onFocusOut()
        }

        function pt(e) {
            if (!e)
                if (window.ShopifyXR) {
                    for (var t in q)
                        if (q.hasOwnProperty(t)) {
                            var i = q[t];
                            if (i.loaded) continue;
                            var n = f("#ModelJson-" + t);
                            window.ShopifyXR.addModels(JSON.parse(n.html())), i.loaded = !0
                        } window.ShopifyXR.setupXRElements()
                } else document.addEventListener("shopify_xr_initialized", function() {
                    pt()
                })
        }

        function mt(e) {
            if (!e)
                for (var t in Q) {
                    var i;
                    Q.hasOwnProperty(t) && (!(i = Q[t]).modelViewerUi && Shopify && (i.modelViewerUi = new Shopify.ModelViewerUI(i.$element)), function(e) {
                        var t = Y[e.sectionId];
                        e.$container.on("mediaVisible", function() {
                            t.$element.attr("data-shopify-model3d-id", e.modelId), theme.config.isTouch || e.modelViewerUi.play()
                        }), e.$container.on("mediaHidden", function() {
                            t.$element.attr("data-shopify-model3d-id", t.defaultId), e.modelViewerUi.pause()
                        }).on("xrLaunch", function() {
                            e.modelViewerUi.pause()
                        })
                    }(i))
                }
        }

        function ft(e) {
            var t = theme.config.bpSmall ? f("[data-scroll-to]").offset().top - 60 : f("#CollectionAjaxResult").offset().top + 1;
            theme.config.stickyHeader && (t -= f(".site-header").outerHeight(!0)), e ? f("html, body").animate({
                scrollTop: t
            }, 300) : f("html, body").scrollTop(t)
        }

        function gt() {
            var e = f(".site-header").outerHeight(!0);
            f(K.filters).css("top", e + 10)
        }

        function yt(e) {
            e = -1 === e.indexOf("?") ? e + "?view=ajax" : e + "&view=ajax", f("#CollectionAjaxResult").load(e + " #CollectionAjaxContent", function() {
                W = !1, theme.reinitSection("collection-template"), theme.collectionTemplate.reinit()
            }.bind(this))
        }

        function vt() {
            f("#RecoverPasswordForm").toggleClass("hide"), f("#CustomerLoginForm").toggleClass("hide")
        }

        function bt(e) {
            wt(e), f(window).on("scroll." + e, {
                id: e
            }, f.throttle(150, wt))
        }

        function wt(e) {
            var t, i, n;
            if ("string" == typeof e) t = e;
            else {
                if (!e.data) return;
                t = e.data.id
            }
            if (theme.isElementVisible(f("#" + t))) {
                if (ne[t] && "unmuted" === ne[t].style) return;
                oe[n = t] && "function" == typeof oe[n].playVideo && oe[n].playVideo()
            } else oe[i = t] && "function" == typeof oe[i].pauseVideo && oe[i].pauseVideo()
        }

        function St(e, t) {
            var i = f("#" + t),
                n = i.attr("id"),
                o = oe[n];
            switch (e.data) {
                case -1:
                    ne[n].attemptedToPlay && (Ct(i), i.closest(ie.videoParent).addClass(te.interactable));
                    break;
                case 0:
                    ne[n] && ne[n].loop && o.playVideo();
                    break;
                case 1:
                    Ct(i);
                    break;
                case 3:
                    ne[n].attemptedToPlay = !0
            }
        }

        function _t(e) {
            e.closest(ie.videoParent).addClass(te.loading)
        }

        function Ct(e) {
            e.closest(ie.videoParent).removeClass(te.loading).addClass(te.loaded)
        }

        function kt(e) {
            var t = this.$container = f(e),
                i = this.sectionId = t.attr("data-section-id");
            this.inModal = t.closest(".modal").length, this.$modal, this.settings = {
                enableHistoryState: t.data("enable-history-state") || !1,
                namespace: ".product-" + i,
                inventory: t.data("inventory") || !1,
                incomingInventory: t.data("incoming-inventory") || !1,
                modalInit: !1,
                slickMainInitialized: !1,
                slickThumbInitialized: !1,
                thumbArrows: !1,
                thumbVertical: !1,
                hasImages: !0,
                hasMultipleImages: !1,
                has3d: !1,
                imageSize: "620x",
                videoLooping: t.data("video-looping")
            }, this.inModal && (this.settings.enableHistoryState = !1, this.settings.namespace = ".product-" + i + "-modal", this.$modal = f("#QuickShopModal-" + i)), this.selectors = {
                variantsJson: "VariantsJson-" + i,
                currentVariantJson: "CurrentVariantJson-" + i,
                video: "ProductVideo-" + i,
                media: "[data-product-media-type-model]",
                closeMedia: ".product-single__close-media",
                photoThumbs: ".product__thumb-" + i,
                thumbSlider: "#ProductThumbs-" + i,
                mainSlider: "#ProductPhotos-" + i,
                imageContainer: "[data-product-images]",
                productImageMain: ".product-image-main--" + i,
                dotsContainer: ".product__photo-dots--" + i,
                priceWrapper: ".product__price-wrap-" + i,
                price: "#ProductPrice-" + i,
                comparePrice: "#ComparePrice-" + i,
                savePrice: "#SavePrice-" + i,
                priceA11y: "#PriceA11y-" + i,
                comparePriceA11y: "#ComparePriceA11y-" + i,
                unitWrapper: ".product__unit-price-wrapper--" + i,
                unitPrice: ".product__unit-price--" + i,
                unitPriceBaseUnit: ".product__unit-base--" + i,
                sku: "#Sku-" + i,
                inventory: "#ProductInventory-" + i,
                incomingInventory: "#ProductIncomingInventory-" + i,
                addToCart: "#AddToCart-" + i,
                addToCartText: "#AddToCartText-" + i,
                originalSelectorId: "#ProductSelect-" + i,
                singleOptionSelector: ".variant__input-" + i,
                variantColorSwatch: ".variant__input--color-swatch-" + i,
                modalFormHolder: "#ProductFormHolder-" + i,
                formContainer: "#AddToCartForm-" + i,
                availabilityContainer: "StoreAvailabilityHolder-" + i
            }, this.$mainSlider = f(this.selectors.mainSlider), this.$thumbSlider = f(this.selectors.thumbSlider), this.$firstProductImage = this.$mainSlider.find("img").first(), this.$firstProductImage.length || (this.settings.hasImages = !1), this.init()
        }

        function $t(e) {
            var t = this.$container = f(e),
                i = this.sectionId = t.attr("data-section-id");
            this.url = t.data("url"), this.selectors = {
                recommendations: "#Recommendations-" + i,
                placeholder: ".product-recommendations-placeholder",
                sectionClass: " .product-recommendations",
                productResults: ".grid-product"
            }, this.init()
        }

        function It(e) {
            this.container = e, this.baseUrl = e.dataset.baseUrl, this.productTitle = e.dataset.productName
        }

        function Tt(e) {
            var t, i, n = f(e);
            this.namespace = ".collection-header", (this.$heroContainer = n.find(ce)).length ? (this.checkIfNeedReload(), n.data("parallax") && (t = n.find(de), i = {
                namespace: this.namespace
            }, theme.parallaxSections[this.namespace] = new theme.Parallax(t, i))) : theme.headerNav.disableOverlayHeader()
        }

        function Vt(e) {
            this.$container = f(e), this.init()
        }

        function Pt(e) {
            this.container = e, this.sectionId = f(e).attr("data-section-id"), this.namespace = ".collection-" + this.sectionId, this.init()
        }

        function xt(e) {
            var t = this.$container = f(e);
            this.sectionId = t.attr("data-section-id");
            theme.reinitSection("slideshow-section"), this.initDrawers(), theme.headerNav.init(), theme.announcementBar.init(), this.cache = {}, this.cacheSelectors(), this.cache.$localeDisclosure.length && (this.localeDisclosure = new theme.Disclosure(this.cache.$localeDisclosure)), this.cache.$currencyDisclosure.length && (this.currencyDisclosure = new theme.Disclosure(this.cache.$currencyDisclosure)), Shopify.designMode && setTimeout(function() {
                f("body").trigger("resize")
            }, 500)
        }

        function Ot(e) {
            this.$container = f(e);
            this.cache = {}, this.cacheSelectors(), this.cache.$localeDisclosure.length && (this.localeDisclosure = new theme.Disclosure(this.cache.$localeDisclosure)), this.cache.$currencyDisclosure.length && (this.currencyDisclosure = new theme.Disclosure(this.cache.$currencyDisclosure))
        }

        function Dt(e) {
            var t = this.$container = f(e),
                i = (t.parent(), t.attr("data-section-id"));
            this.slideshow = "#Slideshow-" + i;
            this.namespace = "." + i;
            var n, o = f(e).find(".hero");
            o.length && theme.loadImageSection(o), this.init(), t.data("parallax") && (n = {
                namespace: this.namespace
            }, theme.parallaxSections[this.namespace] = new theme.Parallax(t.find(Ce), n))
        }

        function Mt(e) {
            var t = this.$container = f(e),
                i = (this.sectionId = t.attr("data-section-id"), this.youtubePlayerId = "YouTubeVideo-" + this.sectionId);
            this.namespace = "." + i;
            var n, o = this.vimeoPlayerId = "Vimeo-" + this.sectionId,
                a = (this.$vimeoTrigger = f("#VimeoTrigger-" + this.sectionId), "Mp4Video-" + this.sectionId),
                s = f("#" + i),
                r = f("#" + o),
                c = f("#" + a);
            this.vimeoPlayer = [], s.length && (this.youtubeVideoId = s.data("video-id"), this.initYoutubeVideo()), r.length && (this.vimeoVideoId = r.data("video-id"), this.initVimeoVideo()), c.length && (Et(c), n = a, document.querySelector("#" + n).play().then(function() {}).catch(function(e) {
                c.attr("controls", ""), Ft(c)
            }))
        }

        function Lt(e) {
            var t, i, n = "string" == typeof e ? e : !!e.data && e.data.id;
            n && (theme.isElementVisible(f("#" + n)) ? Ie[i = n] && "function" == typeof Ie[i].playVideo && Ie[i].playVideo() : Ie[t = n] && "function" == typeof Ie[t].pauseVideo && Ie[t].pauseVideo())
        }

        function At(e) {
            e.closest(xe.videoParent).addClass(Oe.loading)
        }

        function Et(e) {
            e.closest(xe.videoParent).removeClass(Oe.loading).addClass(Oe.loaded)
        }

        function Ft(e) {
            e.closest(xe.videoParent).addClass(Oe.interactable), e.closest(xe.promoContainer).addClass(Oe.interactable)
        }

        function jt(e) {
            var t, i, n = f(e),
                o = n.attr("data-section-id");
            this.namespace = "." + o, n.length && n.data("parallax") && (t = n.find(De), i = {
                namespace: this.namespace,
                desktopOnly: !0
            }, theme.parallaxSections[this.namespace] = new theme.Parallax(t, i))
        }

        function Bt(e) {
            var t = (this.$container = f(e)).attr("data-section-id"),
                i = (this.wrapper = ".testimonials-wrapper", this.slider = "#Testimonials-" + t),
                n = f(i);
            this.sliderActive = !1;
            var o = f.extend({}, Le, {
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: !0
            });
            (Me = n.data("count")) < Le.slidesToShow && (Le.slidesToShow = Me, Le.slidesToScroll = Me), n.on("init", this.a11y.bind(this)), theme.config.bpSmall ? this.init(n, o) : this.init(n, Le), f("body").on("matchSmall", function() {
                this.init(n, o)
            }.bind(this)), f("body").on("matchLarge", function() {
                this.init(n, Le)
            }.bind(this))
        }

        function Rt(e) {
            var t = this.$container = f(e),
                i = t.attr("data-section-id");
            this.cookieName = "newsletter-" + i, t.length && "/challenge" !== window.location.pathname && (this.data = {
                secondsBeforeShow: t.data("delay-seconds"),
                daysBeforeReappear: t.data("delay-days"),
                cookie: Cookies.get(this.cookieName),
                testMode: t.data("test-mode")
            }, this.modal = new theme.Modals("NewsletterPopup-" + i, "newsletter-popup-modal"), (t.find(".errors").length || t.find(".note--success").length) && this.modal.open(), t.find(".note--success").length ? this.closePopup(!0) : (f("body").on("modalClose." + t.attr("id"), this.closePopup.bind(this)), this.data.cookie && !this.data.testMode || this.initPopupDelay()))
        }

        function Ht(e) {
            this.$container = f(e), this.sectionId = this.$container.attr("data-section-id"), this.namespace = ".map-" + this.sectionId, this.$map = this.$container.find(Re), this.key = this.$map.data("api-key"), this.key && (this.checkVisibility(), f(window).on("scroll" + this.namespace, f.throttle(50, this.checkVisibility.bind(this))))
        }

        function Ut(e) {
            this.tagFilters()
        }

        function zt(e, t) {
            this.$container = f(e), this.sectionId = t, this.namespace = ".photoswipe-" + this.sectionId, this.gallery, this.$images, this.inSlideshow = !1, "false" !== this.$container.attr("data-zoom") && ("true" === this.$container.attr("data-has-slideshow") && (this.inSlideshow = !0), this.init())
        }
        theme.utils = {
            defaultTo: function(e, t) {
                return null == e || e != e ? t : e
            }
        }, theme.a11y = {
            trapFocus: function(e) {
                var t = {
                        focusin: e.namespace ? "focusin." + e.namespace : "focusin",
                        focusout: e.namespace ? "focusout." + e.namespace : "focusout",
                        keydown: e.namespace ? "keydown." + e.namespace : "keydown.handleFocus"
                    },
                    i = e.$container.find(f('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])').filter(":visible")),
                    n = i[0],
                    o = i[i.length - 1];
                e.$elementToFocus || (e.$elementToFocus = e.$container), e.$container.attr("tabindex", "-1"), e.$elementToFocus.focus(), f(document).off("focusin"), f(document).on(t.focusout, function() {
                    f(document).off(t.keydown)
                }), f(document).on(t.focusin, function(e) {
                    e.target !== o && e.target !== n || f(document).on(t.keydown, function(e) {
                        var t;
                        9 === (t = e).keyCode && (t.target !== o || t.shiftKey || (t.preventDefault(), n.focus()), t.target === n && t.shiftKey && (t.preventDefault(), o.focus()))
                    })
                })
            },
            removeTrapFocus: function(e) {
                var t = e.namespace ? "focusin." + e.namespace : "focusin";
                e.$container && e.$container.length && e.$container.removeAttr("tabindex"), f(document).off(t)
            },
            lockMobileScrolling: function(e, t) {
                (t || f(document.documentElement).add("body")).on("touchmove" + e, function() {
                    return !1
                })
            },
            unlockMobileScrolling: function(e, t) {
                (t || f(document.documentElement).add("body")).off(e)
            }
        }, f(".cart_plus").click(function() {
            var e = f(this).next().val(),
                t = parseInt(e);
            f(this).next().val(++t)
        }), f(".cart_minus").click(function() {
            var e = f(this).prev().val(),
                t = parseInt(e);
            1 <= t && f(this).prev().val(--t)
        }), theme.Sections = function() {
            this.constructors = {}, this.instances = [], f(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
        }, theme.Sections.prototype = f.extend({}, theme.Sections.prototype, {
            createInstance: function(e, t, i) {
                var n = f(e),
                    o = n.attr("data-section-id"),
                    a = n.attr("data-section-type");
                if (void 0 !== (t = t || this.constructors[a])) {
                    if (i)
                        if (this._findInstance(o)) return;
                    var s = f.extend(new t(e), {
                        id: o,
                        type: a,
                        container: e
                    });
                    this.instances.push(s)
                }
            },
            _onSectionLoad: function(e, t, i) {
                AOS && AOS.refreshHard();
                var n, o = t || f("[data-section-id]", e.target)[0];
                o && (this.createInstance(o), n = t ? i : this._findInstance(e.detail.sectionId), t || this._loadSubSections(), n && "function" == typeof n.onLoad && n.onLoad(e))
            },
            _loadSubSections: function() {
                AOS && AOS.refreshHard(), f("[data-subsection]").each(function(e, t) {
                    this._onSectionLoad(null, t, f(t).data("section-id"))
                }.bind(this))
            },
            _onSectionUnload: function(e) {
                var t = this._removeInstance(e.detail.sectionId);
                t && "function" == typeof t.onUnload && t.onUnload(e)
            },
            _onSelect: function(e) {
                var t = this._findInstance(e.detail.sectionId);
                t && "function" == typeof t.onSelect && t.onSelect(e)
            },
            _onDeselect: function(e) {
                var t = this._findInstance(e.detail.sectionId);
                t && "function" == typeof t.onDeselect && t.onDeselect(e)
            },
            _onBlockSelect: function(e) {
                var t = this._findInstance(e.detail.sectionId);
                t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
            },
            _onBlockDeselect: function(e) {
                var t = this._findInstance(e.detail.sectionId);
                t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e)
            },
            _findInstance: function(e) {
                for (var t = 0; t < this.instances.length; t++)
                    if (this.instances[t].id === e) return this.instances[t]
            },
            _removeInstance: function(e) {
                for (var t, i = this.instances.length; i--;)
                    if (this.instances[i].id === e) {
                        t = this.instances[i], this.instances.splice(i, 1);
                        break
                    } return t
            },
            register: function(e, i, n) {
                this.constructors[e] = i;
                var t = f("[data-section-type=" + e + "]");
                n && (t = f("[data-section-type=" + e + "]", n)), t.each(function(e, t) {
                    this.createInstance(t, i, n)
                }.bind(this))
            }
        }), theme.Currency = {
            formatMoney: function(e, t) {
                t = t || theme.settings.moneyFormat, "string" == typeof e && (e = e.replace(".", ""));
                var i = "",
                    n = /\{\{\s*(\w+)\s*\}\}/,
                    o = t || "${{amount}}";

                function a(e, t, i, n) {
                    if (t = theme.utils.defaultTo(t, 2), i = theme.utils.defaultTo(i, ","), n = theme.utils.defaultTo(n, "."), isNaN(e) || null == e) return 0;
                    var o = (e = (e / 100).toFixed(t)).split(".");
                    return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (o[1] ? n + o[1] : "")
                }
                switch (o.match(n)[1]) {
                    case "amount":
                        i = a(e, 2);
                        break;
                    case "amount_no_decimals":
                        i = a(e, 0);
                        break;
                    case "amount_with_comma_separator":
                        i = a(e, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        i = a(e, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        i = a(e, 0, " ")
                }
                return o.replace(n, i)
            },
            getBaseUnit: function(e) {
                if (e && e.unit_price_measurement && e.unit_price_measurement.reference_value) return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit
            }
        }, theme.Images = {
            imageSize: function(e) {
                if (!e) return "620x";
                var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                return null !== t ? t[1] : null
            },
            getSizedImageUrl: function(e, t) {
                if (!e) return e;
                if (null == t) return e;
                if ("master" === t) return this.removeProtocol(e);
                var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null == i) return null;
                var n = e.split(i[0]),
                    o = i[0];
                return this.removeProtocol(n[0] + "_" + t + o)
            },
            removeProtocol: function(e) {
                return e.replace(/http(s)?:/, "")
            },
            lazyloadImagePath: function(e) {
                var t;
                return null !== e && (t = e.replace(/(\.[^.]*)$/, "_{width}x$1")), t
            }
        }, theme.Variants = (Ye.prototype = f.extend({}, Ye.prototype, {
            _getCurrentOptions: function() {
                var e = f.map(f(this.singleOptionSelector, this.$container), function(e) {
                    var t = f(e),
                        i = t.attr("type"),
                        n = {};
                    return ("radio" !== i && "checkbox" !== i || !!t[0].checked) && (n.value = t.val(), n.index = t.data("index"), n)
                });
                return e = this._compact(e)
            },
            _getVariantFromOptions: function() {
                var e = this._getCurrentOptions(),
                    t = this.variants,
                    n = !1;
                return t.forEach(function(t) {
                    var i = !0;
                    t.options, e.forEach(function(e) {
                        i = i && t[e.index] === e.value
                    }), i && (n = t)
                }), n || null
            },
            _onSelectChange: function() {
                var e = this._getVariantFromOptions();
                this.$container.trigger({
                    type: "variantChange",
                    variant: e
                }), document.dispatchEvent(new CustomEvent("variant:change", {
                    detail: {
                        variant: e
                    }
                })), e && (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateUnitPrice(e), this._updateSKU(e), this.currentVariant = e, this.enableHistoryState && this._updateHistoryState(e))
            },
            _updateImages: function(e) {
                var t = e.featured_image || {},
                    i = this.currentVariant.featured_image || {};
                e.featured_image && t.src !== i.src && this.$container.trigger({
                    type: "variantImageChange",
                    variant: e
                })
            },
            _updatePrice: function(e) {
                e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
                    type: "variantPriceChange",
                    variant: e
                })
            },
            _updateUnitPrice: function(e) {
                e.unit_price !== this.currentVariant.unit_price && this.$container.trigger({
                    type: "variantUnitPriceChange",
                    variant: e
                })
            },
            _updateSKU: function(e) {
                e.sku !== this.currentVariant.sku && this.$container.trigger({
                    type: "variantSKUChange",
                    variant: e
                })
            },
            _updateHistoryState: function(e) {
                var t;
                history.replaceState && e && (t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id, window.history.replaceState({
                    path: t
                }, "", t))
            },
            _updateMasterSelect: function(e) {
                f(this.originalSelectorId, this.$container).val(e.id)
            },
            _compact: function(e) {
                for (var t = -1, i = null == e ? 0 : e.length, n = 0, o = []; ++t < i;) {
                    var a = e[t];
                    a && (o[n++] = a)
                }
                return o
            }
        }), Ye), theme.rte = {
            init: function() {
                theme.rte.wrapTable(), theme.rte.wrapVideo(), theme.rte.imageLinks()
            },
            wrapTable: function() {
                f(".rte table").wrap('<div class="table-wrapper"></div>')
            },
            wrapVideo: function() {
                var e = f('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
                    t = e.add("iframe#admin_bar_iframe");
                e.each(function() {
                    f(this).parents(".video-wrapper").length || f(this).wrap('<div class="video-wrapper"></div>')
                }), t.each(function() {
                    this.src
                })
            },
            imageLinks: function() {
                f(".rte a img").parent().addClass("rte__image")
            }
        }, theme.LibraryLoader = (p = {
            requested: "requested",
            loaded: "loaded"
        }, m = {
            youtubeSdk: {
                tagId: "youtube-sdk",
                src: "https://www.youtube.com/iframe_api",
                type: u = "script"
            },
            shopifyXr: {
                tagId: "shopify-model-viewer-xr",
                src: (e = "https://cdn.shopify.com/shopifycloud/") + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
                type: u
            },
            modelViewerUi: {
                tagId: "shopify-model-viewer-ui",
                src: e + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
                type: u
            },
            modelViewerUiStyles: {
                tagId: "shopify-model-viewer-ui-styles",
                src: e + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
                type: h = "link"
            }
        }, {
            load: function(e, t) {
                var i, n, o, a, s, r, c, d = m[e];
                if (d && d.status !== p.requested)
                    if (t = t || function() {}, d.status !== p.loaded) {
                        switch (d.status = p.requested, d.type) {
                            case u:
                                s = d, r = t, (c = document.createElement("script")).src = s.src, c.addEventListener("load", function() {
                                    s.status = p.loaded, r()
                                }), i = c;
                                break;
                            case h:
                                n = d, o = t, (a = document.createElement("link")).href = n.src, a.rel = "stylesheet", a.type = "text/css", a.addEventListener("load", function() {
                                    n.status = p.loaded, o()
                                }), i = a
                        }
                        i.id = d.tagId, d.element = i;
                        var l = document.getElementsByTagName(d.type)[0];
                        l.parentNode.insertBefore(i, l)
                    } else t()
            }
        }), theme.Modals = (Je.prototype.init = function() {
            f(this.config.open).attr("aria-expanded", "false"), f(this.config.open).on("click", this.open.bind(this)), this.$modal.find(this.config.close).on("click", this.close.bind(this)), f("body").on("drawerOpen", function() {
                this.close()
            }.bind(this))
        }, Je.prototype.open = function(e) {
            var t = !1;
            this.modalIsOpen || (e ? e.preventDefault() : t = !0, e && e.stopPropagation && (e.stopPropagation(), this.$activeSource = f(e.currentTarget).attr("aria-expanded", "true")), this.modalIsOpen && !t && this.close(), this.$modal.prepareTransition().addClass(this.config.openClass), this.nodes.$parent.addClass(this.config.bodyOpenClass), this.isSolid && this.nodes.$parent.addClass(this.config.bodyOpenSolidClass), this.modalIsOpen = !0, theme.a11y.trapFocus({
                $container: this.$modal,
                $elementToFocus: this.$focusOnOpen,
                namespace: "modal_focus"
            }), f("body").trigger("productModalOpen").trigger("modalOpen." + this.id), this.bindEvents())
        }, Je.prototype.close = function() {
            this.modalIsOpen && (f(document.activeElement).trigger("blur"), this.$modal.prepareTransition().removeClass(this.config.openClass).addClass(this.config.closingClass), this.nodes.$parent.removeClass(this.config.bodyOpenClass), this.nodes.$parent.addClass(this.config.bodyClosingClass), window.setTimeout(function() {
                this.nodes.$parent.removeClass(this.config.bodyClosingClass), this.$modal.removeClass(this.config.closingClass), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false").focus()
            }.bind(this), 550), this.isSolid && this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass), this.modalIsOpen = !1, theme.a11y.removeTrapFocus({
                $container: this.$modal,
                namespace: "modal_focus"
            }), f("body").trigger("modalClose." + this.id), this.unbindEvents())
        }, Je.prototype.bindEvents = function() {
            this.nodes.$parent.on("keyup.modal", function(e) {
                27 === e.keyCode && this.close()
            }.bind(this)), this.config.closeOffContentClick && (this.$modal.on("click.modal", this.close.bind(this)), this.nodes.$modalContent.on("click.modal", function(e) {
                e.stopImmediatePropagation()
            }))
        }, Je.prototype.unbindEvents = function() {
            this.nodes.$parent.off(".modal"), this.config.closeOffContentClick && (this.$modal.off(".modal"), this.nodes.$modalContent.off(".modal"))
        }, Je), theme.Drawers = (Ge.prototype = f.extend({}, Ge.prototype, {
            init: function() {
                var e = f(this.config.open);
                e.attr("aria-expanded", "false"), e.on("click", this.open.bind(this)), this.$drawer.find(this.config.close).on("click", this.close.bind(this)), f("body").on("productModalOpen", function() {
                    this.close()
                }.bind(this))
            },
            open: function(e, t) {
                var i;
                e && e.preventDefault(), this.isOpen || (e && e.stopPropagation ? (e.stopPropagation(), this.$activeSource = f(e.currentTarget).attr("aria-expanded", "true")) : t && (i = f(t), this.$activeSource = i.attr("aria-expanded", "true")), this.$drawer.prepareTransition().addClass(this.config.activeDrawer), this.$nodes.parent.addClass(this.config.openClass), this.isOpen = !0, theme.a11y.trapFocus({
                    $container: this.$drawer,
                    namespace: "drawer_focus"
                }), f("body").trigger("drawerOpen").trigger("drawerOpen." + this.config.id), this.bindEvents())
            },
            close: function() {
                this.isOpen && (f(document.activeElement).trigger("blur"), this.$drawer.prepareTransition().removeClass(this.config.activeDrawer), this.$nodes.parent.removeClass(this.config.openClass), this.$nodes.parent.addClass(this.config.closingClass), window.setTimeout(function() {
                    this.$nodes.parent.removeClass(this.config.closingClass), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false").focus()
                }.bind(this), 500), this.isOpen = !1, theme.a11y.removeTrapFocus({
                    $container: this.$drawer,
                    namespace: "drawer_focus"
                }), this.unbindEvents())
            },
            bindEvents: function() {
                this.ignoreScrollLock || theme.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page), this.$nodes.page.on("click" + this.config.namespace, function(e) {
                    var t = f(e.target);
                    if (!this.elementInsideDrawer(t)) return this.close(), !1
                }.bind(this)), this.$nodes.parent.on("keyup" + this.config.namespace, function(e) {
                    27 === e.keyCode && this.close()
                }.bind(this))
            },
            unbindEvents: function() {
                this.ignoreScrollLock || theme.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page), this.$nodes.parent.off(this.config.namespace), this.$nodes.page.off(this.config.namespace)
            },
            elementInsideDrawer: function(e) {
                return this.$drawer.find(e).length
            }
        }), Ge), theme.cart = {
            getCart: function() {
                return f.getJSON(theme.routes.cart)
            },
            changeItem: function(e, t) {
                return this._updateCart({
                    type: "POST",
                    url: theme.routes.cartChange,
                    data: "quantity=" + t + "&id=" + e,
                    dataType: "json"
                })
            },
            addItemFromForm: function(e) {
                return this._updateCart({
                    type: "POST",
                    url: theme.routes.cartAdd,
                    data: e,
                    dataType: "json"
                })
            },
            _updateCart: function(e) {
                return f.ajax(e).then(function(e) {
                    return e
                }.bind(this))
            },
            updateNote: function(e) {
                var t = {
                    type: "POST",
                    url: "/cart/update.js",
                    data: "note=" + theme.cart.attributeToString(e),
                    dataType: "json",
                    success: function(e) {},
                    error: function(e, t) {}
                };
                f.ajax(t)
            },
            attributeToString: function(e) {
                return "string" != typeof e && "undefined" === (e += "") && (e = ""), e.trim()
            }
        }, f(function() {
            f("body").on("click", ".cart__checkout", function() {
                f(this).addClass("btn--loading")
            }), f("body").on("change", 'textarea[name="note"]', function() {
                var e = f(this).val();
                theme.cart.updateNote(e)
            }), f("body").on("click", ".cart__checkout--ajax", function(e) {
                if (!f("#CartAgree").is(":checked")) return alert(theme.strings.cartTermsConfirmation), f(this).removeClass("btn--loading"), !1
            }), f("body").on("click", ".cart__checkout--page", function(e) {
                if (!f("#CartPageAgree").is(":checked")) return alert(theme.strings.cartTermsConfirmation), f(this).removeClass("btn--loading"), !1
            })
        }), theme.QtySelector = (n = ".js-qty__num", o = ".js-qty__adjust--plus", a = ".js-qty__adjust--minus", We.prototype = f.extend({}, We.prototype, {
            initEventListeners: function() {
                this.$plus.on("click", function() {
                    var e = this.validateQty(this.$input.val());
                    this.addQty(e)
                }.bind(this)), this.$minus.on("click", function() {
                    var e = this.validateQty(this.$input.val());
                    this.subtractQty(e)
                }.bind(this)), this.$input.on("change", function() {
                    var e = this.validateQty(this.$input.val());
                    this.changeQty(e)
                }.bind(this))
            },
            addQty: function(e) {
                var t = e + 1;
                this.changeQty(t)
            },
            subtractQty: function(e) {
                var t = e - 1;
                t <= this.minValue && (t = this.minValue), this.changeQty(t)
            },
            changeQty: function(e) {
                this.$input.val(e), f("body").trigger("qty" + this.options.namespace, [this.options.key, e])
            },
            validateQty: function(e) {
                return parseFloat(e) == parseInt(e) && !isNaN(e) || (e = 1), parseInt(e)
            }
        }), We), theme.CartDrawer = (d = ".ajaxcart", l = "#CartContainer", t = "#CartTemplate", i = ".cart-link__bubble", Ke.prototype = f.extend({}, Ke.prototype, {
            initEventListeners: function() {
                f("body").on("updateCart" + d, this.initQtySelectors.bind(this)), f("body").on("updateCart" + d, this.updateCartNotification.bind(this)), f("body").on("added.ajaxProduct", function(e, t) {
                    theme.cart.getCart().then(function(e) {
                        this.buildCart(e, !0, t)
                    }.bind(this))
                }.bind(this))
            },
            buildCart: function(e, t, i) {
                if (this.loading(!0), this.emptyCart(), 0 === e.item_count) f(l).append('<div class="drawer__scrollable"><p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty + "</p></div>");
                else {
                    var n, a = [],
                        s = {},
                        r = 1;
                    f.each(e.items, function(e, i) {
                        var t = null !== i.image ? i.image.replace(/(\.[^.]*)$/, "_180x$1") : "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
                        null !== i.properties && f.each(i.properties, function(e, t) {
                            "_" !== e.charAt(0) && t || delete i.properties[e]
                        });
                        var n = 0;
                        if (0 !== i.line_level_discount_allocations.length)
                            for (var o in i.line_level_discount_allocations) n = i.line_level_discount_allocations[o].amount, i.line_level_discount_allocations[o].formattedAmount = theme.Currency.formatMoney(n, theme.settings.moneyFormat);
                        r += 2, s = {
                            key: i.key,
                            url: i.url,
                            img: t,
                            animationRow: r,
                            name: i.product_title,
                            variation: i.variant_title,
                            properties: i.properties,
                            itemQty: i.quantity,
                            price: theme.Currency.formatMoney(i.price, theme.settings.moneyFormat),
                            unitPrice: theme.Currency.formatMoney(i.unit_price, theme.settings.moneyFormat),
                            unitBase: theme.Currency.getBaseUnit(i),
                            discountedPrice: theme.Currency.formatMoney(i.price - i.total_discount / i.quantity, theme.settings.moneyFormat),
                            discounts: i.line_level_discount_allocations,
                            discountsApplied: 0 !== i.line_level_discount_allocations.length,
                            vendor: i.vendor
                        }, a.push(s)
                    }), r += 2;
                    var o = 0;
                    if (0 !== e.cart_level_discount_applications.length)
                        for (var c in e.cart_level_discount_applications) o = e.cart_level_discount_applications[c].total_allocated_amount, e.cart_level_discount_applications[c].formattedAmount = theme.Currency.formatMoney(o, theme.settings.moneyFormat);
                    n = {
                        items: a,
                        note: e.note,
                        lastAnimationRow: r,
                        cartDiscounts: e.cart_level_discount_applications,
                        cartDiscountsApplied: 0 !== e.cart_level_discount_applications.length,
                        totalPrice: theme.Currency.formatMoney(e.total_price, theme.settings.moneyFormat)
                    }, f(l).append(this.template(n))
                }
                this.status.loaded = !0, this.loading(!1), f("body").trigger("updateCart" + d, e), Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize(), !0 === t && this.drawer.open(!1, i), document.dispatchEvent(new CustomEvent("cart:updated", {
                    detail: {
                        cart: e
                    }
                }))
            },
            initQtySelectors: function() {
                f(l).find(".js-qty__wrapper").each(function(e, t) {
                    new theme.QtySelector(f(t), {
                        namespace: ".cart-drawer"
                    })
                }.bind(this)), f("body").on("qty.cart-drawer", this.updateItem.bind(this))
            },
            updateItem: function(e, t, i) {
                this.status.loading || (this.loading(!0), theme.cart.changeItem(t, i).then(function(e) {
                    this.updateSuccess(e)
                }.bind(this)).catch(function(e) {
                    this.updateError(e)
                }.bind(this)).always(function() {
                    this.loading(!1)
                }.bind(this)))
            },
            loading: function(e) {
                (this.status.loading = e) ? f(l).addClass("is-loading"): f(l).removeClass("is-loading")
            },
            emptyCart: function() {
                f(l).empty()
            },
            updateSuccess: function(e) {
                this.buildCart(e)
            },
            updateError: function(e) {
                e.responseJSON && e.responseJSON.description
            },
            updateCartNotification: function(e, t) {
                0 < t.items.length ? f(i).addClass("cart-link__bubble--visible") : f(i).removeClass("cart-link__bubble--visible")
            }
        }), Ke), theme.AjaxProduct = (s = {
            loading: !1
        }, Xe.prototype = f.extend({}, Xe.prototype, {
            addItemFromForm: function(e, t) {
                var i;
                e.preventDefault(), s.loading || (this.$addToCart.addClass("btn--loading"), s.loading = !0, i = this.$form.serialize(), theme.cart.addItemFromForm(i).then(function(e) {
                    this.success(e)
                }.bind(this)).catch(function(e) {
                    this.error(e)
                }.bind(this)).always(function() {
                    s.loading = !1, this.$addToCart.removeClass("btn--loading")
                }.bind(this)))
            },
            success: function(e) {
                this.$form.find(".errors").remove(), f("body").trigger("added.ajaxProduct", this.$addToCart), document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
                    detail: {
                        product: e
                    }
                }))
            },
            error: function(e) {
                this.$form.find(".errors").remove(), e.responseJSON && e.responseJSON.description && (this.$form.prepend('<div class="errors text-center">' + e.responseJSON.description + "</div>"), document.dispatchEvent(new CustomEvent("ajaxProduct:error", {
                    detail: {
                        errorMessage: e.responseJSON.description
                    }
                })))
            }
        }), Xe), theme.collapsibles = (r = ".collapsible-trigger", c = ".collapsible-content__inner", g = {
            hide: "hide",
            open: "is-open",
            autoHeight: "collapsible--auto-height"
        }, v = !(y = ".collapsible"), {
            init: function() {
                f(r).each(function() {
                    var e = f(this),
                        t = e.hasClass(g.open);
                    e.attr("aria-expanded", t)
                }), f("body, .modal__inner").off(y).on("click" + y, r, function() {
                    var e, t, i, n, o, a;
                    v || (v = !0, e = f(this), t = e.hasClass(g.open), i = e.attr("aria-controls"), n = f("#" + i), o = n.find(c).outerHeight(), a = e.hasClass(g.autoHeight), t && a && setTimeout(function() {
                        Ze(n, o = 0, t, a)
                    }, 0), t && !a && (o = 0), e.attr("aria-expanded", !t).toggleClass(g.open, !t), Ze(n, o, t, a))
                })
            }
        }), theme.headerNav = (_ = f(document.documentElement).add("body"), C = f("#MainContent"), I = {
            namespace: ".siteNav",
            wrapperOverlayed: !($ = {
                hasDropdownClass: "site-nav--has-dropdown",
                hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
                dropdownActive: "is-focused",
                overlaidBodyClass: "overlaid-header",
                stickyBodyClass: "sticky-header"
            }),
            overlayedClass: "is-light",
            stickyEnabledClass: "header-wrapper--sticky",
            stickyEnabled: !(k = {
                wrapper: ".header-wrapper",
                siteHeader: ".site-header",
                searchBtn: ".js-search-header",
                closeSearch: ".js-search-header-close",
                searchContainer: ".site-header__search-container",
                logoContainer: ".site-header__logo",
                logo: ".site-header__logo img",
                navigation: ".site-navigation",
                megamenu: ".megamenu",
                navContainerWithLogo: ".header-item--logo",
                navItems: ".site-nav__item",
                navLinks: ".site-nav__link",
                navLinksWithDropdown: ".site-nav__link--has-dropdown",
                navDropdownLinks: ".site-nav__dropdown-link--second-level"
            }),
            stickyActive: !1,
            stickyInitialized: !1,
            forceStopSticky: !1,
            stickyClass: "site-header--stuck",
            openTransitionClass: "site-header--opening",
            lastScroll: 0
        }, {
            init: function() {
                b = f(window), f(k.navContainerWithLogo), f(k.logoContainer), f(k.navigation), w = f(k.wrapper), S = f(k.siteHeader), I.wrapperOverlayed = theme.settings.overlayHeader = w.hasClass(I.overlayedClass), I.stickyEnabled = S.data("sticky"), I.stickyEnabled && (tt(), b.on("resize" + I.namespace, f.debounce(150, tt))), I.wrapperOverlayed && f("body").addClass($.overlaidBodyClass),
                    function() {
                        var n = !1,
                            o = !1,
                            a = !1;

                        function i(e) {
                            var t, i = e.parent();
                            i.hasClass($.hasDropdownClass) && (i.addClass($.dropdownActive), n = !0), theme.config.isTouch || a || (t = theme.config.isTouch ? "touchend" : "click", a = !0, f("body").on(t + I.namespace, function() {
                                r(), f("body").off(I.namespace), a = !1
                            }))
                        }

                        function s(e, t) {
                            var i = e.parent();
                            (i.hasClass($.hasSubDropdownClass) || t) && (i.addClass($.dropdownActive), o = !0)
                        }

                        function r() {
                            e(), c()
                        }

                        function e() {
                            f(k.navItems).removeClass($.dropdownActive)
                        }

                        function c() {
                            f(k.navDropdownLinks).parent().removeClass($.dropdownActive)
                        }
                        theme.config.isTouch && (f(k.navLinksWithDropdown).on("touchend" + I.namespace, function(e) {
                            var t = f(this);
                            t.parent().hasClass($.dropdownActive) ? window.location.replace(t.attr("href")) : (e.preventDefault(), r(), i(t))
                        }), f(k.navDropdownLinks).on("touchend" + I.namespace, function(e) {
                            var t = f(this),
                                i = t.parent();
                            !i.hasClass($.hasSubDropdownClass) || i.hasClass($.dropdownActive) ? window.location.replace(t.attr("href")) : (e.preventDefault(), c(), s(t))
                        }), f("body").on("touchend" + I.namespace, function() {
                            e(), c()
                        }), f(k.megamenu).on("touchend" + I.namespace, function(e) {
                            e.stopImmediatePropagation()
                        })), f(k.navLinks).on("focusin mouseover" + I.namespace, function() {
                            n && e(), o && c(), i(f(this))
                        }), f(k.navLinks).on("mouseleave" + I.namespace, function() {
                            e(), c()
                        }), f(k.navDropdownLinks).on("focusin" + I.namespace, function() {
                            o && c(), s(f(this), !0)
                        })
                    }(), f(k.searchBtn).on("click" + I.namespace, function(e) {
                        e.preventDefault(), f(k.searchContainer).addClass("is-active"), _.addClass("js-drawer-open--search"), theme.a11y.trapFocus({
                            $container: f(k.searchContainer),
                            namespace: "header_search",
                            $elementToFocus: f(k.searchContainer).find("input")
                        }), theme.config.bpSmall && I.stickyEnabled && I.lastScroll < 300 && window.scrollTo(0, 0), theme.a11y.lockMobileScrolling(I.namespace), C.on("click" + I.namespace, function() {
                            return et(), !1
                        }), _.on("keyup" + I.namespace, function(e) {
                            27 === e.keyCode && et()
                        })
                    }), f(k.closeSearch).on("click" + I.namespace, function() {
                        et()
                    })
            },
            disableOverlayHeader: function() {
                f(k.wrapper).removeClass(I.stickyEnabledClass).removeClass(I.overlayedClass), f("body").removeClass($.overlaidBodyClass), I.wrapperOverlayed = !1
            },
            unload: function() {
                f(window).off(I.namespace), f(k.searchBtn).off(I.namespace), f(k.closeSearch).off(I.namespace), _.off(I.namespace), f(k.navLinks).off(I.namespace), f(k.navDropdownLinks).off(I.namespace)
            }
        }), theme.Slideshow = function() {
            this.$slideshow = null;
            var i = "is-init",
                o = "animate-out",
                n = "slideshow-wrapper",
                a = "slick-slide",
                s = "slick-current",
                r = "slideshow__pause",
                t = "is-paused";

            function e(e, t) {
                this.$slideshow = f(e), this.$wrapper = this.$slideshow.closest("." + n), this.$pause = this.$wrapper.find("." + r), this.settings = {
                    accessibility: !0,
                    arrows: !!t.arrows,
                    dots: !!t.dots,
                    fade: !!t.fade,
                    speed: t.speed ? t.speed : 500,
                    draggable: !0,
                    touchThreshold: 5,
                    pauseOnHover: !1,
                    rtl: theme.config.rtl,
                    autoplay: !!t.autoplay,
                    autoplaySpeed: this.$slideshow.data("speed")
                }, this.$slideshow.off("beforeChange"), this.$slideshow.off("afterSlideChange"), this.$slideshow.on("init", this.init.bind(this)), this.$slideshow.on("beforeChange", this.beforeSlideChange.bind(this)), this.$slideshow.on("afterChange", this.afterSlideChange.bind(this)), this.$slideshow.slick(this.settings), this.$pause.on("click", this._togglePause.bind(this))
            }
            return e.prototype = f.extend({}, e.prototype, {
                init: function(e, t) {
                    this.$slideshowList = t.$list, this.$slickDots = t.$dots, this.$allSlides = t.$slides, this.slideCount = t.slideCount, this.$slideshow.addClass(i), this._a11y(), this._clonedLazyloading()
                },
                beforeSlideChange: function(e, t, i, n) {
                    t.$slider.find("." + s).addClass(o)
                },
                afterSlideChange: function(e, t, i) {
                    t.$slider.find("." + a).removeClass(o)
                },
                destroy: function() {
                    this.$slideshow.slick("unslick")
                },
                _play: function() {
                    this.$slideshow.slick("slickPause"), f(r).addClass("is-paused")
                },
                _pause: function() {
                    this.$slideshow.slick("slickPlay"), f(r).removeClass("is-paused")
                },
                _togglePause: function() {
                    var e = this._getSlideshowId(this.$pause);
                    this.$pause.hasClass(t) ? (this.$pause.removeClass(t), f(e).slick("slickPlay")) : (this.$pause.addClass(t), f(e).slick("slickPause"))
                },
                _getSlideshowId: function(e) {
                    return "#Slideshow-" + e.data("id")
                },
                _activeSlide: function() {
                    return this.$slideshow.find(".slick-active")
                },
                _currentSlide: function() {
                    return this.$slideshow.find(".slick-current")
                },
                _nextSlide: function(e) {
                    return this.$slideshow.find('.slideshow__slide[data-slick-index="' + e + '"]')
                },
                _a11y: function() {
                    var t = this.$slideshowList,
                        i = this.settings.autoplay;
                    t && (t.removeAttr("aria-live"), f(n).on("focusin", function(e) {
                        f(n).has(e.target).length && (t.attr("aria-live", "polite"), i && this._pause())
                    }.bind(this)), f(n).on("focusout", function(e) {
                        f(n).has(e.target).length && (t.removeAttr("aria-live"), i && this._play())
                    }.bind(this)))
                },
                _clonedLazyloading: function() {
                    var a = this.$slideshow;
                    a.find(".slick-slide").each(function(e, t) {
                        var i, n, o = f(t);
                        o.hasClass("slick-cloned") && (i = o.data("id"), n = o.find(".hero__image").removeClass("lazyloading").addClass("lazyloaded"), setTimeout(function() {
                            var e = a.find(".slideshow__slide--" + i + ":not(.slick-cloned) .hero__image").attr("style");
                            e && n.attr("style", e)
                        }, this.settings.autoplaySpeed / 1.5))
                    }.bind(this))
                }
            }), e
        }(), theme.announcementBar = (x = {
            accessibility: !(P = !1),
            arrows: !1,
            dots: !1,
            autoplay: !(V = 0),
            autoplaySpeed: 5e3,
            touchThreshold: 20,
            rtl: theme.config.rtl,
            slidesToShow: 1
        }, {
            init: function() {
                var e, t;
                (T = f("#AnnouncementSlider")).length && (V = T.data("block-count"), P = T.data("compact-style"), e = f.extend({}, x, {
                    slidesToShow: P ? 1 : V,
                    slidesToScroll: 1
                }), t = f.extend({}, x, {
                    slidesToShow: 1
                }), theme.config.bpSmall ? ot(T, t) : ot(T, e), f("body").on("matchSmall", function() {
                    ot(T, t)
                }.bind(this)), f("body").on("matchLarge", function() {
                    ot(T, e)
                }.bind(this)))
            },
            onBlockSelect: function(e) {
                var t = f("#AnnouncementSlide-" + e);
                T.length && T.slick("slickPause"), t.length && T.slick("slickGoTo", t.data("index"))
            },
            onBlockDeselect: function(e) {
                T.length && at(T) && T.slick("slickPlay")
            },
            unload: function() {
                at(T) && T.slick("unslick")
            }
        }), theme.predictiveSearch = (D = "", M = !1, L = ".predictive", A = {
            form: "#HeaderSearchForm",
            input: 'input[type="search"]',
            wrapper: ".predictive-results",
            searchButton: "[data-predictive-search-button]",
            resultDiv: "#PredictiveResults",
            resultTemplate: "#PredictiveTemplate"
        }, E = {
            up_arrow: 38,
            down_arrow: 40,
            tab: 9
        }, {
            init: function() {
                var e;
                document.getElementById("shopify-features") && !JSON.parse(document.getElementById("shopify-features").innerHTML).predictiveSearch || (f(A.form).attr("autocomplete", "off"), f(A.form).on("submit" + L, ct), f(A.input, A.form).on("keyup" + L, dt), f(A.searchButton, A.wrapper).on("click" + L, rt), e = f(A.resultTemplate).html(), resultTemplate = Handlebars.compile(e))
            }
        }), theme.initQuickShop = function() {
            var n = [];
            f(".quick-product__btn").each(function() {
                var e = f(this).data("product-id"),
                    t = "QuickShopModal-" + e,
                    i = "quick-modal-" + e; - 1 < n.indexOf(e) ? f('.modal--quick-shop[data-product-id="' + e + '"]').each(function(e) {
                    0 < e && f(this).remove()
                }) : (new theme.Modals(t, i), n.push(e))
            })
        }, theme.videoModal = function() {
            var s, r = null,
                c = {
                    width: 1280,
                    height: 720,
                    playerVars: {
                        autohide: 0,
                        autoplay: 1,
                        branding: 0,
                        cc_load_policy: 0,
                        fs: 0,
                        iv_load_policy: 3,
                        modestbranding: 1,
                        playsinline: 1,
                        quality: "hd720",
                        rel: 0,
                        showinfo: 0,
                        wmode: "opaque"
                    },
                    events: {
                        onReady: function(e) {
                            e.target.playVideo()
                        }
                    }
                },
                d = "VideoHolder",
                l = !1,
                t = {
                    videoHolder: "#" + d,
                    youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
                    mp4Trigger: ".product-video-trigger--mp4",
                    mp4Player: ".product-video-mp4-sound"
                };

            function i(e) {
                var t, i, n = f(e.currentTarget),
                    o = (t = n.attr("href"), !(!(i = t.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/)) || 11 != i[7].length) && i[7]),
                    a = f.extend({}, c, {
                        videoId: o
                    });
                a.playerVars.playsinline = theme.config.bpSmall ? 0 : 1, r = new YT.Player(d, a), s.open(e), l = "youtube"
            }

            function n() {
                f(t.videoHolder).empty()
            }(f(t.youtube).length || f(t.mp4Trigger).length) && (s = new theme.Modals("VideoModal", "video-modal", {
                closeOffContentClick: !0,
                solid: !0
            }), f(t.youtube).on("click", function(e) {
                n(), e.preventDefault(), theme.LibraryLoader.load("youtubeSdk"), theme.config.youTubeReady ? i(e) : f("body").on("youTubeReady", function() {
                    i(e)
                })
            }), f(t.mp4Trigger).on("click", function(e) {
                n(), f(e.currentTarget).next(t.mp4Player).clone().removeClass("hide").appendTo(t.videoHolder), s.open(e), f(t.videoHolder).find("video")[0].play(), l = "mp4"
            }), f("body").on("modalClose.VideoModal", function() {
                r && "youtube" === l ? setTimeout(function() {
                    r.destroy()
                }, 500) : n()
            }))
        }, theme.RecentlyViewed = (F = "#RecentlyViewedProduct", B = !(j = "#RecentlyViewed-"), lt.prototype = f.extend({}, lt.prototype, {
            init: function() {
                if (!B && (B = !0, !f.isEmptyObject(theme.recentlyViewed.recent))) {
                    this.outputContainer = f(j + this.sectionId), this.handle = this.$container.attr("data-product-handle");
                    var e = [];
                    for (handle in theme.recentlyViewed.recent) "undefined" !== handle && e.push(this.getProductInfo(handle));
                    Promise.all(e).then(function(e) {
                        this.setupOutput(e), this.captureProductDetails(e)
                    }.bind(this), function(e) {
                        console.warn("Theme | recently viewed products failed to load")
                    })
                }
            },
            checkVisibility: function() {
                theme.isElementVisible(this.$container, 600) && (this.init(), f(window).off("scroll" + this.namespace))
            },
            getProductInfo: function(i) {
                return new Promise(function(t, e) {
                    theme.recentlyViewed.productInfo.hasOwnProperty(i) ? t(theme.recentlyViewed.productInfo[i]) : jQuery.getJSON("/products/" + i + ".js", function(e) {
                        t(e)
                    })
                })
            },
            setupOutput: function(e) {
                var t, i, n, o = [],
                    a = this.$container.attr("data-recent-count");
                for (key in e) {
                    var s, r, c = e[key];
                    c.handle !== this.handle && void 0 !== c.handle && (c.url_formatted = theme.recentlyViewed.recent[c.handle] ? theme.recentlyViewed.recent[c.handle].url : c.url, c.image_responsive_url = theme.recentlyViewed.recent[c.handle].featuredImage, c.image_aspect_ratio = theme.recentlyViewed.recent[c.handle].aspectRatio, c.on_sale = c.compare_at_price > c.price, c.sold_out = !c.available, c.price_formatted = theme.Currency.formatMoney(c.price, theme.settings.moneyFormat), c.compare_at_price_formatted = theme.Currency.formatMoney(c.compare_at_price, theme.settings.moneyFormat), c.price_min_formatted = theme.Currency.formatMoney(c.price_min, theme.settings.moneyFormat), c.money_saved = theme.Currency.formatMoney(c.compare_at_price - c.price, theme.settings.moneyFormat), (s = c.variants[0]) && s.unit_price && (r = "", s.unit_price_measurement && (1 != s.unit_price_measurement.reference_value && (r += s.unit_price_measurement.reference_value + " "), r += s.unit_price_measurement.reference_unit), c.unit_price = theme.Currency.formatMoney(s.unit_price), "" != r && (c.unit_price += "/" + r)), o.unshift(c))
                }
                t = {
                    items: o.slice(0, a),
                    grid_item_width: this.$container.attr("data-grid-item-class")
                }, 0 !== o.length && (i = f(F).html(), n = Handlebars.compile(i), this.outputContainer.append(n(t)), AOS && AOS.refreshHard())
            },
            captureProductDetails: function(e) {
                for (var t = 0; t < e.length; t++) {
                    var i = e[t];
                    theme.recentlyViewed.productInfo[i.handle] = i
                }
                theme.config.hasSessionStorage && sessionStorage.setItem("recent-products", JSON.stringify(theme.recentlyViewed.productInfo))
            },
            onUnload: function() {
                B = !1, f("window").off(this.namespace)
            }
        }), lt), theme.parallaxSections = {}, theme.Parallax = (ht.prototype = f.extend({}, ht.prototype, {
            init: function(e) {
                var n = this.$window = f(window),
                    o = this.$container.offset().top;
                n.on("scroll" + this.namespace, function(e) {
                    var t = n.scrollTop(),
                        i = (o - t) / 7;
                    this.$container.css({
                        transform: "translate3d(0, " + i + "px, 0)"
                    })
                }.bind(this)), n.on("resize" + this.namespace, f.debounce(350, function() {
                    n.off(this.namespace), !e || theme.config.bpSmall ? this.init() : this.init(!0)
                }.bind(this)))
            },
            desktopInit: function() {
                theme.config.bpSmall || this.init(!0), f("body").on("matchSmall", function() {
                    this.destroy()
                }.bind(this)), f("body").on("matchLarge", function() {
                    this.init(!0)
                }.bind(this))
            },
            destroy: function() {
                this.$container.removeAttr("style"), this.$window.off(this.namespace)
            }
        }), ht), theme.Disclosure = (R = "[data-disclosure-list]", H = "[data-disclosure-toggle]", U = "[data-disclosure-input]", z = "[data-disclosure-option]", N = "disclosure-list--visible", ut.prototype = f.extend({}, ut.prototype, {
            _cacheSelectors: function() {
                this.cache = {
                    $disclosureList: this.$container.find(R),
                    $disclosureToggle: this.$container.find(H),
                    $disclosureInput: this.$container.find(U),
                    $disclosureOptions: this.$container.find(z)
                }
            },
            _connectToggle: function() {
                this.cache.$disclosureToggle.on("click", function(e) {
                    var t = "true" === f(e.currentTarget).attr("aria-expanded");
                    f(e.currentTarget).attr("aria-expanded", !t), this.cache.$disclosureList.toggleClass(N)
                }.bind(this))
            },
            _connectOptions: function() {
                this.cache.$disclosureOptions.on("click", function(e) {
                    e.preventDefault(), this._submitForm(f(e.currentTarget).data("value"))
                }.bind(this))
            },
            _onFocusOut: function() {
                this.cache.$disclosureToggle.on("focusout", function(e) {
                    0 === this.$container.has(e.relatedTarget).length && this._hideList()
                }.bind(this)), this.cache.$disclosureList.on("focusout", function(e) {
                    var t = 0 < f(e.currentTarget).has(e.relatedTarget).length;
                    this.cache.$disclosureList.hasClass(N) && !t && this._hideList()
                }.bind(this)), this.$container.on("keyup", function(e) {
                    27 === e.which && (this._hideList(), this.cache.$disclosureToggle.focus())
                }.bind(this)), f("body").on("click", function(e) {
                    var t = 0 < this.$container.has(e.target).length;
                    this.cache.$disclosureList.hasClass(N) && !t && this._hideList()
                }.bind(this))
            },
            _submitForm: function(e) {
                f("body").addClass("unloading"), this.cache.$disclosureInput.val(e), this.$container.parents("form").submit()
            },
            _hideList: function() {
                this.cache.$disclosureList.removeClass(N), this.cache.$disclosureToggle.attr("aria-expanded", !1)
            },
            unload: function() {
                this.cache.$disclosureOptions.off(), this.cache.$disclosureToggle.off(), this.cache.$disclosureList.off(), this.$container.off()
            }
        }), ut), theme.ProductMedia = (q = {}, Q = {}, Y = {}, J = "[data-product-single-media-group]", G = "[data-shopify-xr]", {
            init: function(e, s) {
                q[s] = {
                    loaded: !1
                }, e.each(function(e) {
                    var t, i = f(this),
                        n = i.data("media-id"),
                        o = f(i.find("model-viewer")[0]),
                        a = o.data("model-id");
                    0 === e && (t = i.closest(J).find(G), Y[s] = {
                        $element: t,
                        defaultId: a
                    }), Q[n] = {
                        modelId: a,
                        sectionId: s,
                        $container: i,
                        $element: o
                    }
                }), window.Shopify.loadFeatures([{
                    name: "shopify-xr",
                    version: "1.0",
                    onLoad: pt
                }, {
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: mt
                }]), theme.LibraryLoader.load("modelViewerUiStyles")
            },
            removeSectionModels: function(e) {
                for (var t in Q) Q.hasOwnProperty(t) && Q[t].sectionId === e && delete Q[t];
                delete q[e]
            }
        }), theme.collectionTemplate = (W = !1, X = {
            combineTags: f((K = {
                collectionGrid: ".collection-grid__wrapper",
                sidebar: "#CollectionSidebar",
                activeTagList: ".tag-list--active-tags",
                tags: ".tag-list a",
                filters: ".collection-filter"
            }).sidebar).data("combine-tags")
        }, Z = {
            activeTag: "tag--active",
            removeTagParent: "tag--remove"
        }, {
            init: function() {
                f(window).on("popstate", function(e) {
                    e && yt(location.href)
                }), theme.config.stickyHeader && (gt(), f(window).on("resize", f.debounce(150, gt))), f("body").on("click", K.tags, function(e) {
                    var t, i, n = f(this);
                    theme.FilterDrawer && theme.FilterDrawer.close(), n.hasClass("no-ajax") || (e.preventDefault(), W || (W = !0, t = (n = f(e.currentTarget)).parent(), i = n.attr("href"), X.combineTags ? t.hasClass(Z.activeTag) ? t.removeClass(Z.activeTag) : (t.addClass(Z.activeTag), n.parent("li").hasClass(Z.removeTagParent) ? f(this).parent().remove() : f(K.activeTagList).append('<li class="tag tag--remove"><a class="btn btn--small">' + n.text() + "</a></li>")) : (f(K.tags).parent().removeClass(Z.activeTag), t.addClass(Z.activeTag)), ft(!0), history.pushState({}, "", i), f(K.collectionGrid).addClass("unload"), yt(i)))
                })
            },
            reinit: function() {
                X.combineTags = f(K.sidebar).data("combine-tags"), ft(!1), theme.reinitProductGridItem(), f("body").trigger("resize")
            }
        }), theme.customerTemplates = {
            init: function() {
                var e, t;
                "#recover" === window.location.hash && vt(), f("#RecoverPassword").on("click", function(e) {
                    e.preventDefault(), vt()
                }), f("#HideRecoverPasswordLink").on("click", function(e) {
                    e.preventDefault(), vt()
                }), f(".reset-password-success").length && f("#ResetSuccess").removeClass("hide"), e = f("#AddressNewForm"), t = f(".js-address-form"), e.length && t.length && (Shopify && f(".js-address-country").each(function() {
                    var e = f(this),
                        t = e.data("country-id"),
                        i = e.data("province-id"),
                        n = e.data("province-container-id");
                    Shopify && new Shopify.CountryProvinceSelector(t, i, {
                        hideElement: n
                    })
                }), f(".address-new-toggle").on("click", function() {
                    e.toggleClass("hide")
                }), f(".address-edit-toggle").on("click", function() {
                    var e = f(this).data("form-id");
                    f("#EditAddress_" + e).toggleClass("hide")
                }), f(".address-delete").on("click", function() {
                    var e = f(this),
                        t = e.data("form-id"),
                        i = e.data("confirm-message");
                    confirm(i || "Are you sure you wish to delete this address?") && Shopify && Shopify.postLink("/account/addresses/" + t, {
                        parameters: {
                            _method: "delete"
                        }
                    })
                }))
            }
        }, theme.Product = (te = {
            onSale: "on-sale",
            disabled: "disabled",
            isModal: "is-modal",
            loading: "loading",
            loaded: "loaded",
            hidden: "hide",
            interactable: "video-interactable",
            visuallyHide: "visually-invisible"
        }, ie = {
            productVideo: ".product__video",
            videoParent: ".product__video-wrapper",
            currentSlide: ".slick-current",
            startingSlide: ".starting-slide"
        }, ne = {}, oe = [], ae = {
            height: "480",
            width: "850",
            playerVars: {
                autohide: 0,
                autoplay: 0,
                branding: 0,
                cc_load_policy: 0,
                controls: 0,
                fs: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                quality: "hd720",
                rel: 0,
                showinfo: 0,
                wmode: "opaque"
            }
        }, kt.prototype = f.extend({}, kt.prototype, {
            init: function() {
                this.inModal && (this.$container.addClass(te.isModal), f("body").off("modalOpen.QuickShopModal-" + this.sectionId).off("modalClose.QuickShopModal-" + this.sectionId), f("body").on("modalOpen.QuickShopModal-" + this.sectionId, this.openModalProduct.bind(this)), f("body").on("modalClose.QuickShopModal-" + this.sectionId, this.closeModalProduct.bind(this))), this.inModal || (this.stringOverrides(), this.formSetup(), this.productSetup(), this.checkIfVideos(), this.createImageCarousels(), this.customMediaListners(), this.addIdToRecentlyViewed())
            },
            formSetup: function() {
                theme.settings.dynamicVariantsEnable && (this.$variantSelectors = f(this.selectors.formContainer).find(this.selectors.singleOptionSelector)), this.initQtySelector(), this.initAjaxProductForm(), this.availabilitySetup(), this.initVariants()
            },
            availabilitySetup: function() {
                var e = document.getElementById(this.selectors.availabilityContainer);
                e && (this.storeAvailability = new theme.StoreAvailability(e))
            },
            productSetup: function() {
                this.setImageSizes(), this.initImageSwitch(), this.initImageZoom(), this.initModelViewerLibraries(), this.initShopifyXrLaunch()
            },
            addIdToRecentlyViewed: function() {
                var e = this.$container.attr("data-product-handle"),
                    t = this.$container.attr("data-product-url"),
                    i = this.$container.attr("data-aspect-ratio"),
                    n = this.$container.attr("data-img-url");
                theme.recentlyViewed.recent.hasOwnProperty(e) && delete theme.recentlyViewed.recent[e], theme.recentlyViewed.recent[e] = {
                    url: t,
                    aspectRatio: i,
                    featuredImage: n
                }, theme.config.hasLocalStorage && window.localStorage.setItem("theme-recent", JSON.stringify(theme.recentlyViewed.recent))
            },
            stringOverrides: function() {
                theme.productStrings = theme.productStrings || {}, f.extend(theme.strings, theme.productStrings)
            },
            initVariants: function() {
                var e;
                document.getElementById(this.selectors.variantsJson) && (this.variantsObject = JSON.parse(document.getElementById(this.selectors.variantsJson).innerHTML), e = {
                    $container: this.$container,
                    enableHistoryState: this.settings.enableHistoryState,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    variants: this.variantsObject
                }, f(this.selectors.variantColorSwatch).length && f(this.selectors.variantColorSwatch).on("change", function(e) {
                    var t = f(e.currentTarget),
                        i = t.data("color-name"),
                        n = t.data("color-index");
                    this.updateColorName(i, n)
                }.bind(this)), this.variants = new theme.Variants(e), this.storeAvailability && (this.storeAvailability.updateContent(this.variants.currentVariant.id), this.$container.on("variantChange" + this.settings.namespace, this.updateAvailability.bind(this))), this.$container.on("variantChange" + this.settings.namespace, this.updateCartButton.bind(this)).on("variantImageChange" + this.settings.namespace, this.updateVariantImage.bind(this)).on("variantPriceChange" + this.settings.namespace, this.updatePrice.bind(this)).on("variantUnitPriceChange" + this.settings.namespace, this.updateUnitPrice.bind(this)), f(this.selectors.sku).length && this.$container.on("variantSKUChange" + this.settings.namespace, this.updateSku.bind(this)), (this.settings.inventory || this.settings.incomingInventory) && this.$container.on("variantChange" + this.settings.namespace, this.updateInventory.bind(this)), theme.settings.dynamicVariantsEnable && document.getElementById(this.selectors.currentVariantJson) && (this.currentVariantObject = JSON.parse(document.getElementById(this.selectors.currentVariantJson).innerHTML), this.$variantSelectors.on("change" + this.settings.namespace, this.updateVariantAvailability.bind(this)), this.setCurrentVariantAvailability(this.currentVariantObject, !0)))
            },
            initQtySelector: function() {
                this.$container.find(".js-qty__wrapper").each(function() {
                    new theme.QtySelector(f(this), {
                        namespace: ".product"
                    })
                })
            },
            initAjaxProductForm: function() {
                "drawer" === theme.settings.cartType && new theme.AjaxProduct(f(this.selectors.formContainer))
            },
            setCurrentVariantAvailability: function(t) {
                var e = {
                    option1: [],
                    option2: [],
                    option3: []
                };
                this.disableVariantGroup(f(this.selectors.formContainer).find(".variant-input-wrap"));
                var i, n, o, a, s = this.variantsObject.filter(function(e) {
                        return t.id !== e.id && (t.option2 === e.option2 && t.option3 === e.option3 || t.option1 === e.option1 && t.option3 === e.option3 || t.option1 === e.option1 && t.option2 === e.option2 || void 0)
                    }),
                    r = {
                        variant: t
                    },
                    s = Object.assign({}, r, s);
                for (var c in s) s.hasOwnProperty(c) && (n = (i = s[c]).option1, o = i.option2, a = i.option3, n && -1 === e.option1.indexOf(n) && e.option1.push(n), o && -1 === e.option2.indexOf(o) && e.option2.push(o), a && -1 === e.option3.indexOf(a) && e.option3.push(a));
                e.option1.length && this.enableVariantOptionByValue(e.option1, "option1"), e.option2.length && this.enableVariantOptionByValue(e.option2, "option2"), e.option3.length && this.enableVariantOptionByValue(e.option3, "option3")
            },
            updateVariantAvailability: function(e, t, i) {
                var n, o, a;
                a = t && i ? (o = t, i) : (n = f(e.currentTarget), o = n.val() ? n.val() : e.currentTarget.value, n.data("index"));
                var s = this.variantsObject.filter(function(e) {
                    return e[a] === o
                });
                f(this.selectors.formContainer).find(".variant-input-wrap").each(function(e, t) {
                    var i = f(t),
                        n = i.data("index");
                    if (n !== a) {
                        this.disableVariantGroup(i);
                        for (var o = 0; o < s.length; o++) this.enableVariantOption(i, s[o][n])
                    }
                }.bind(this))
            },
            disableVariantGroup: function(e) {
                "dropdown" === theme.settings.dynamicVariantType ? e.find("option").prop("disabled", !0) : (e.find("input").prop("disabled", !0), e.find("label").toggleClass("disabled", !0))
            },
            enableVariantOptionByValue: function(e, t) {
                for (var i = f(this.selectors.formContainer).find('.variant-input-wrap[data-index="' + t + '"]'), n = 0; n < e.length; n++) this.enableVariantOption(i, e[n])
            },
            enableVariantOption: function(e, t) {
                var i;
                t = t.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1"), "dropdown" === theme.settings.dynamicVariantType ? e.find('option[value="' + t + '"]').prop("disabled", !1) : ((i = e.find('.variant-input[data-value="' + t + '"]')).find("input").prop("disabled", !1), i.find("label").toggleClass("disabled", !1))
            },
            updateColorName: function(e, t) {
                f("#VariantColorLabel-" + this.sectionId + "-" + t).text(e)
            },
            updateCartButton: function(e) {
                var t, i = e.variant;
                i ? i.available ? (f(this.selectors.addToCart).removeClass(te.disabled).prop("disabled", !1), t = f(this.selectors.addToCartText).data("default-text"), f(this.selectors.addToCartText).html(t)) : (f(this.selectors.addToCart).addClass(te.disabled).prop("disabled", !0), f(this.selectors.addToCartText).html(theme.strings.soldOut)) : (f(this.selectors.addToCart).addClass(te.disabled).prop("disabled", !0), f(this.selectors.addToCartText).html(theme.strings.unavailable))
            },
            updatePrice: function(e) {
                var t, i = e.variant;
                i && (f(this.selectors.price).html(theme.Currency.formatMoney(i.price, theme.settings.moneyFormat)).show(), i.compare_at_price > i.price ? (f(this.selectors.comparePrice).html(theme.Currency.formatMoney(i.compare_at_price, theme.settings.moneyFormat)), f(this.selectors.priceWrapper).removeClass("hide"), f(this.selectors.price).addClass(te.onSale), f(this.selectors.comparePriceA11y).attr("aria-hidden", "false"), f(this.selectors.priceA11y).attr("aria-hidden", "false"), t = i.compare_at_price - i.price, t = "percent" == theme.settings.saveType ? Math.round(100 * t / i.compare_at_price) + "%" : theme.Currency.formatMoney(t, theme.settings.moneyFormat), f(this.selectors.savePrice).removeClass("hide").html(theme.strings.savePrice.replace("[saved_amount]", t))) : (f(this.selectors.priceWrapper).addClass("hide"), f(this.selectors.price).removeClass(te.onSale), f(this.selectors.comparePriceA11y).attr("aria-hidden", "true"), f(this.selectors.priceA11y).attr("aria-hidden", "true"), f(this.selectors.savePrice).addClass("hide")))
            },
            updateUnitPrice: function(e) {
                var t = e.variant;
                t && t.unit_price ? (f(this.selectors.unitPrice).html(theme.Currency.formatMoney(t.unit_price, theme.settings.moneyFormat)), f(this.selectors.unitPriceBaseUnit).text(theme.Currency.getBaseUnit(t)), f(this.selectors.unitWrapper).removeClass("hide").removeClass(te.visuallyHide)) : f(this.selectors.unitWrapper).addClass(te.visuallyHide)
            },
            updateSku: function(e) {
                var t = e.variant,
                    i = "";
                t && (t.sku && (i = t.sku), f(this.selectors.sku).html(i))
            },
            updateInventory: function(e) {
                var t, i, n, o = e.variant;
                if (!o || !o.inventory_management || "continue" === o.inventory_policy) return this.toggleInventoryQuantity(!1), void this.toggleIncomingInventory(!1);
                "shopify" === o.inventory_management && window.inventories && window.inventories[this.sectionId] && (variantInventoryObject = window.inventories[this.sectionId][o.id], n = !(i = !0), ((t = variantInventoryObject.quantity) <= 0 || t > theme.settings.inventoryThreshold) && (i = !1), this.toggleInventoryQuantity(i, t), !i && variantInventoryObject.incoming && (n = !0), this.toggleIncomingInventory(n, o.available, variantInventoryObject.next_incoming_date))
            },
            updateAvailability: function(e) {
                var t = e.variant;
                t && this.storeAvailability.updateContent(t.id)
            },
            toggleInventoryQuantity: function(e, t) {
                this.settings.inventory || (e = !1), e ? f(this.selectors.inventory).removeClass("hide").text(theme.strings.stockLabel.replace("[count]", t)) : f(this.selectors.inventory).addClass("hide")
            },
            toggleIncomingInventory: function(e, t, i) {
                var n;
                this.settings.incomingInventory || (e = !1), e ? (n = t ? theme.strings.willNotShipUntil.replace("[date]", i) : theme.strings.willBeInStockAfter.replace("[date]", i), i || (n = theme.strings.waitingForStock), f(this.selectors.incomingInventory).removeClass("hide").text(n)) : f(this.selectors.incomingInventory).addClass("hide")
            },
            checkIfVideos: function() {
                var e = this.$mainSlider.find(ie.productVideo);
                if (!e.length) return !1;
                var t = [];
                return e.each(function() {
                    var e = f(this).data("video-type");
                    t.indexOf(e) < 0 && t.push(e)
                }), -1 < t.indexOf("youtube") && (theme.config.youTubeReady ? this.loadYoutubeVideos(e) : (theme.LibraryLoader.load("youtubeSdk"), f("body").on("youTubeReady" + this.settings.namespace, function() {
                    this.loadYoutubeVideos(e)
                }.bind(this)))), -1 < t.indexOf("mp4") && this.loadMp4Videos(e), t
            },
            loadMp4Videos: function(e) {
                e.each(function() {
                    var e, t = f(this);
                    "mp4" == t.data("video-type") && (e = t.attr("id"), t.data("video-id"), ne[e] = {
                        type: "mp4",
                        divId: e,
                        style: t.data("video-style")
                    })
                })
            },
            loadYoutubeVideos: function(e) {
                for (var t in e.each(function() {
                        var o, e, t = f(this);
                        "youtube" == t.data("video-type") && (o = t.attr("id"), e = t.data("youtube-id"), ne[o] = {
                            type: "youtube",
                            id: o,
                            videoId: e,
                            style: t.data("video-style"),
                            loop: t.data("video-loop"),
                            attemptedToPlay: !1,
                            events: {
                                onReady: function(e) {
                                    var t, i, n;
                                    t = e, i = f("#" + o), n = i.attr("id"), oe[n] = t.target, oe[n], _t(i), "muted" === ne[n].style ? oe[n].mute() : Ct(i), !i.closest(ie.startingSlide).length && 1 !== i.data("image-count") || "muted" !== ne[n].style || (oe[n].playVideo(), bt(n))
                                },
                                onStateChange: function(e) {
                                    St(e, o)
                                }
                            }
                        })
                    }), ne) {
                    var i;
                    "youtube" === ne[t].type && ne.hasOwnProperty(t) && ("muted" === (i = f.extend({}, ae, ne[t])).style || (i.playerVars.controls = 1, i.playerVars.autoplay = 0), oe[t] = new YT.Player(t, i))
                }
                ee = !0
            },
            initVideo: function(e) {
                var t = e.data("video-type"),
                    i = e.attr("id");
                "mp4" === t && "muted" === ne[i].style && this.playMp4Video(i), "youtube" === t && ee && "muted" === ne[i].style && this.requestToPlayYoutubeVideo(i), this.inModal && this.resizeSlides()
            },
            stopVideo: function(e, t) {
                e || (this.stopYoutubeVideo(), this.stopMp4Video()), "youtube" === t && this.stopYoutubeVideo(e), "mp4" === t && this.stopMp4Video(e)
            },
            getVideoType: function(e) {
                return e.data("video-type")
            },
            getVideoId: function(e) {
                return e.attr("id")
            },
            requestToPlayYoutubeVideo: function(e, t) {
                theme.config.youTubeReady && (_t(f("#" + e)), "function" == typeof oe[e].playVideo ? this.playYoutubeVideo(e, t) : setTimeout(function() {
                    this.playYoutubeVideo(e, t)
                }.bind(this), 1e3))
            },
            playYoutubeVideo: function(e, t) {
                Ct(f("#" + e)), "function" == typeof oe[e].playVideo && oe[e].playVideo(), t || bt(e)
            },
            stopYoutubeVideo: function(e) {
                if (theme.config.youTubeReady)
                    if (e && oe[e]) "function" == typeof oe[e].pauseVideo && oe[e].pauseVideo(), f(window).off("scroll." + e);
                    else
                        for (key in oe) this.$container.find("#" + key).length && "function" == typeof oe[key].pauseVideo && (oe[key].pauseVideo(), f(window).off("scroll." + key))
            },
            playMp4Video: function(e) {
                var t = f("#" + e);
                Ct(t);
                var i = t[0].play();
                void 0 !== i && i.then(function() {}).catch(function(e) {
                    t[0].setAttribute("controls", ""), t.closest(ie.videoParent).attr("data-video-style", "unmuted")
                })
            },
            stopMp4Video: function(e) {
                if (e) f("#" + e)[0].pause();
                else
                    for (var t in ne) {
                        var i;
                        !this.$container.find("#" + t).length || "mp4" !== ne[t].type || (i = f("#" + ne[t].divId)[0]) && "function" == typeof i.pause && i.pause()
                    }
            },
            initImageZoom: function() {
                var e = f(this.selectors.imageContainer, this.$container);
                new theme.Photoswipe(e[0], this.sectionId)
            },
            setImageSizes: function() {
                var e;
                !this.settings.hasImages || (e = this.$firstProductImage[0].currentSrc) && (this.settings.imageSize = theme.Images.imageSize(e))
            },
            updateVariantImage: function(e) {
                var t = e.variant,
                    i = (theme.Images.getSizedImageUrl(t.featured_media.preview_image.src, this.settings.imageSize), f('.product__thumb[data-id="' + t.featured_media.id + '"]')),
                    n = this._slideIndex(i.closest(".product__thumb-item"));
                void 0 !== n && this.$mainSlider.slick("slickGoTo", n)
            },
            initImageSwitch: function() {
                f(this.selectors.photoThumbs).length && f(this.selectors.photoThumbs).on("click", function(e) {
                    e.preventDefault()
                }).on("focus", function(e) {
                    var t;
                    !this.settings.slickThumbInitialized || void 0 !== (t = f(e.currentTarget).data("index")) && this.$thumbSlider.slick("slickGoTo", t)
                }.bind(this)).on("keydown", function(e) {
                    13 === e.keyCode && this.$container.find(ie.currentSlide).focus()
                }.bind(this))
            },
            createImageCarousels: function() {
                var e, t, i, n;
                !this.$thumbSlider.length || f(this.selectors.photoThumbs).length < 2 ? (e = f(this.selectors.productImageMain).find(ie.productVideo)).length && this.initVideo(e) : (this.settings.hasMultipleImages = !0, 
                    this.settings.has3d = this.$container.find(this.selectors.media).length,
                    i = 0, 
                    // t = this.$mainSlider.find(".starting-slide"), 
                    // i = this._slideIndex(t), 
                    this.$mainSlider.off("init"),
                    this.$mainSlider.off("beforeChange"),
                    this.$mainSlider.on("init", 
                                        this.mainSlideInit.bind(this)),
                    this.$mainSlider.on("beforeChange", this.beforeSlideChange.bind(this)), this.$thumbSlider.on("init", this.thumbSlideInit.bind(this)), this.mainSliderArgs = {
                    infinite: !this.settings.has3d,
                    arrows: !1,
                    dots: !0,
                    adaptiveHeight: !0,
                    rtl: theme.config.rtl,
                    initialSlide: i,
                    appendDots: this.selectors.dotsContainer
                }, this.thumbSliderArgs = {
                    accessibility: !1,
                    rtl: theme.config.rtl,
                    initialSlide: i
                }, n = this.setSliderArgs(), this.initSliders(n), f("body").on("matchSmall matchLarge", function() {
                    var e = this.setSliderArgs();
                    this.initSliders(e)
                }.bind(this)), AOS && AOS.refresh())
            },
            initSliders: function(e) {
                this.destroyImageCarousels(), this.$mainSlider.slick(e.main), theme.config.bpSmall || (this.$thumbSlider.slick(e.thumbs), console.log("helloo")), this.settings.slickMainInitialized = !0
            },
            setSliderArgs: function() {
                var e = {},
                    t = this.settings.thumbVertical = "beside" === this.$thumbSlider.data("position"),
                    i = this.settings.thumbArrows = this.$thumbSlider.data("arrows");
                return theme.config.bpSmall ? (e.main = this.mainSliderArgs, e.thumbs = this.thumbSliderArgs) : (e.main = f.extend({}, this.mainSliderArgs, {
                    asNavFor: this.selectors.thumbSlider,
                    adaptiveHeight: !t,
                    dots: !1,
                    infinite: !1,
                    fade: !0
                }), e.thumbs = f.extend({}, this.thumbSliderArgs, {
                    asNavFor: this.selectors.mainSlider,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: i,
                    dots: !1,
                    vertical: t,
                    verticalSwiping: t,
                    focusOnSelect: !0,
                    infinite: !1,
                    customHeightMatching: !i && t,
                    customSlideAdvancement: !0
                })), e
            },
            destroyImageCarousels: function() {
                this.$mainSlider && this.settings.slickMainInitialized && (this.$mainSlider.slick("unslick"), this.settings.slickMainInitialized = !1), this.$thumbSlider && this.settings.slickThumbInitialized && (this.$thumbSlider.slick("unslick"), this.settings.slickThumbInitialized = !1), this.settings.slickMainInitialized = !1, this.settings.slickThumbInitialized = !1
            },
            mainSlideInit: function(e, t) {
                var i = t.$slider.find(ie.currentSlide).find(ie.productVideo);
                i.length && this.initVideo(i)
            },
            thumbSlideInit: function(e, t) {
                this.settings.slickThumbInitialized = !0, this.settings.thumbArrows && this.$thumbSlider.on("setPosition", this.thumbSlideArrowVisibility.bind(this))
            },
            thumbSlideArrowVisibility: function(e, t) {
                var i = t.$slider,
                    n = i.find(".slick-arrow"),
                    o = !1;
                this.settings.thumbVertical ? i.find(".slick-track").height() >= i.height() && (o = !0) : i.find(".slick-track").width() >= i.width() && (o = !0), o ? n.removeClass("hide") : n.addClass("hide")
            },
            beforeSlideChange: function(e, t, i, n) {
                var o, a, s, r, c = t.$slider,
                    d = c.find(ie.currentSlide),
                    l = d.find(".product__video"),
                    h = c.find('.slick-slide[data-slick-index="' + n + '"]'),
                    u = h.find(".product__video");
                i !== n && l.length && (o = this.getVideoType(l), (a = this.getVideoId(l)) && this.stopVideo(a, o)), u.length && (s = this.getVideoType(u), (r = this.getVideoId(u)) && "youtube" === s && (ee ? ne[r] && "muted" === ne[r].style && this.requestToPlayYoutubeVideo(r, !0) : f("body").on("youTubeReady" + this.settings.namespace, function() {
                    ne[r] && "muted" === ne[r].style && this.requestToPlayYoutubeVideo(r, !0)
                }.bind(this))), r && ne[r] && "muted" === ne[r].style && "mp4" === s && this.playMp4Video(r), r && ne[r] && "muted" != ne[r].style && Ct(f("#" + r)));
                var p = d.find(this.selectors.media);
                p.length && p.trigger("mediaHidden");
                var m = h.find(this.selectors.media);
                m.length && (m.trigger("mediaVisible"), h.find(".shopify-model-viewer-ui__button").attr("tabindex", 0), h.find(".product-single__close-media").attr("tabindex", 0))
            },
            resizeSlides: function() {
                this.settings.hasMultipleImages && (f(window).trigger("resize.slick"), setTimeout(function() {
                    this.$mainSlider && this.settings.slickMainInitialized && this.$mainSlider.slick("setPosition"), this.$thumbSlider && this.settings.slickThumbInitialized && this.$thumbSlider.slick("setPosition")
                }.bind(this), 500))
            },
            _slideIndex: function(e) {
                return e.data("index")
            },
            openModalProduct: function() {
                var e, t, i = !1;
                this.settings.modalInit ? i = !0 : (t = (e = f(this.selectors.modalFormHolder)).data("url"), e.data("template") || (t += "?view=ajax"), e.load(t + " #AddToCartForm-" + this.sectionId, function() {
                    e.addClass("is-active"), this.formSetup(), Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init()
                }.bind(this)), this.productSetup(), this.loadModalContent(), this.createImageCarousels(), this.customMediaListners(), this.settings.modalInit = !0, document.dispatchEvent(new CustomEvent("quickview:loaded", {
                    detail: {
                        productId: this.sectionId
                    }
                }))), this.resizeSlides(), document.dispatchEvent(new CustomEvent("quickview:open", {
                    detail: {
                        initialized: i,
                        productId: this.sectionId
                    }
                })), this.addIdToRecentlyViewed()
            },
            closeModalProduct: function() {
                this.stopVideo(), f("body").off(this.settings.namespace), f(window).off(this.settings.namespace)
            },
            loadModalContent: function() {
                var e = this.checkIfVideos();
                e && -1 < e.indexOf("mp4") && this.$modal.find('.product__video[data-video-type="mp4"]').find(".product__video-src").each(function(e, t) {
                    var i = f(t),
                        n = i.attr("src"),
                        o = i.attr("type"),
                        a = document.createElement("source");
                    a.src = n, a.type = o, i.after(a)
                }.bind(this))
            },
            initModelViewerLibraries: function() {
                var e = f(this.selectors.media, this.$container);
                e.length < 1 || theme.ProductMedia.init(e, this.sectionId)
            },
            initShopifyXrLaunch: function() {
                var e = this;
                f(document).on("shopify_xr_launch", function() {
                    f(e.selectors.productMediaWrapper + ":not(." + te.hidden + ")", e.$container).trigger("xrLaunch")
                })
            },
            customMediaListners: function() {
                f("body").on("click", this.selectors.closeMedia, function() {
                    this.$mainSlider.find(ie.currentSlide).find(this.selectors.media).trigger("mediaHidden")
                }.bind(this)), this.$container.find("model-viewer").on("shopify_model_viewer_ui_toggle_play", function(e) {
                    this.mediaLoaded(e)
                }.bind(this)).on("shopify_model_viewer_ui_toggle_pause", function(e) {
                    this.mediaUnloaded(e)
                }.bind(this))
            },
            mediaLoaded: function(e) {
                this.$container.find(this.selectors.closeMedia).removeClass("hide"), this.toggleSliderSwiping(!1)
            },
            mediaUnloaded: function(e) {
                this.$container.find(this.selectors.closeMedia).addClass("hide"), this.toggleSliderSwiping(!0)
            },
            toggleSliderSwiping: function(e) {
                this.$mainSlider && this.settings.slickMainInitialized && (this.$mainSlider.slick("slickSetOption", "swipe", e), this.$mainSlider.slick("slickSetOption", "draggable", e), this.$mainSlider.slick("slickSetOption", "touchMove", e), this.$mainSlider.slick("slickSetOption", "accessibility", e))
            },
            onUnload: function() {
                this.$container.off(this.settings.namespace), f("body").off(this.settings.namespace), this.destroyImageCarousels(), theme.ProductMedia.removeSectionModels(this.sectionId)
            }
        }), kt), theme.Recommendations = ($t.prototype = f.extend({}, $t.prototype, {
            init: function() {
                var e, t, i, n, o = f(this.selectors.recommendations);
                o.length && !1 !== o.data("enable") && (e = o.find(this.selectors.placeholder), t = o.data("product-id"), i = o.data("limit"), n = this.url + "?section_id=product-recommendations&limit=" + i + "&product_id=" + t, e.load(n + this.selectors.sectionClass, function(e) {
                    theme.reinitProductGridItem(o), this.updateVariantInventory(o), 0 === f(e).find(this.selectors.sectionClass).find(this.selectors.productResults).length && o.addClass("hide")
                }.bind(this)))
            },
            updateVariantInventory: function(e) {
                window.inventories = window.inventories || {}, e.find(".js-product-inventory-data").each(function() {
                    var e = f(this),
                        t = e.data("section-id");
                    window.inventories[t] = {}, f(".js-variant-inventory-data", e).each(function() {
                        var e = f(this);
                        window.inventories[t][e.data("id")] = {
                            quantity: e.data("quantity"),
                            incoming: e.data("incoming"),
                            next_incoming_date: e.data("date")
                        }
                    })
                })
            }
        }), $t), theme.StoreAvailability = (se = ".js-drawer-open-availability", re = "[data-availability-product-title]", It.prototype = Object.assign({}, It.prototype, {
            updateContent: function(e) {
                var t = this.baseUrl + "/variants/" + e + "/?section_id=store-availability";
                this.container.innerHTML = "";
                var i = this;
                fetch(t).then(function(e) {
                    return e.text()
                }).then(function(e) {
                    "" !== e.trim() && (i.container.innerHTML = e, i.container.innerHTML = i.container.firstElementChild.innerHTML, i.container.querySelector(se) && (i.drawer = new theme.Drawers("StoreAvailabilityDrawer", "availability"), i.container.querySelector(re).textContent = i.productTitle))
                })
            }
        }), It), theme.CollectionHeader = (ce = ".collection-hero", de = ".parallax-container", Tt.prototype = f.extend({}, Tt.prototype, {
            checkIfNeedReload: function() {
                Shopify.designMode && theme.settings.overlayHeader && (f(".header-wrapper").hasClass("is-light") || f(".header-wrapper").hasClass("header-wrapper--sticky") || location.reload())
            },
            onUnload: function() {
                theme.parallaxSections[this.namespace] && (theme.parallaxSections[this.namespace].destroy(), delete theme.parallaxSections[this.namespace])
            }
        }), Tt), theme.CollectionSidebar = (le = !1, Vt.prototype = f.extend({}, Vt.prototype, {
            init: function() {
                this.onUnload(), le = "drawer" === this.$container.data("style"), theme.FilterDrawer = new theme.Drawers("FilterDrawer", "collection-filters", !0)
            },
            forceReload: function() {
                this.init()
            },
            onSelect: function() {
                if (theme.FilterDrawer) {
                    if (!le) return void theme.FilterDrawer.close();
                    (le || theme.config.bpSmall) && theme.FilterDrawer.open()
                }
            },
            onDeselect: function() {
                theme.FilterDrawer && theme.FilterDrawer.close()
            },
            onUnload: function() {
                theme.FilterDrawer && theme.FilterDrawer.close()
            }
        }), Vt), theme.Collection = (he = ".grid-product__color-image", ue = ".color-swatch--with-image", pe = "#SortBy", me = "data-default-sortby", Pt.prototype = f.extend({}, Pt.prototype, {
            init: function() {
                this.$container = f(this.container);
                var e = this.sectionId = this.$container.attr("data-section-id");
                this.namespace = ".collection-" + e, this.$sortSelect = f(pe), this.$sortSelect.on("change", this.onSortChange.bind(this)), this.defaultSort = this.getDefaultSortValue(), this.initParams(), this.colorSwatchHovering(), theme.reinitSection("collection-sidebar")
            },
            initParams: function() {
                if (this.queryParams = {}, location.search.length)
                    for (var e, t = location.search.substr(1).split("&"), i = 0; i < t.length; i++) 1 < (e = t[i].split("=")).length && (this.queryParams[decodeURIComponent(e[0])] = decodeURIComponent(e[1]))
            },
            getSortValue: function() {
                return this.$sortSelect.val() || this.defaultSort
            },
            getDefaultSortValue: function() {
                return this.$sortSelect.attr(me)
            },
            onSortChange: function() {
                this.queryParams.sort_by = this.getSortValue(), this.queryParams.page && delete this.queryParams.page, window.location.search = f.param(this.queryParams)
            },
            colorSwatchHovering: function() {
                f(he).length && f(ue).on({
                    mouseenter: function(e) {
                        $el = f(e.currentTarget);
                        var t = $el.data("variant-id"),
                            i = $el.data("variant-image");
                        f(".grid-product__color-image--" + t).css("background-image", "url(" + i + ")").addClass("is-active")
                    },
                    mouseleave: function(e) {
                        $el = f(e.currentTarget);
                        var t = $el.data("variant-id");
                        f(".grid-product__color-image--" + t).removeClass("is-active")
                    }
                })
            },
            forceReload: function() {
                this.onUnload(), this.init()
            },
            onUnload: function() {
                f(window).off(this.namespace), this.$container.off(this.namespace), f(ue).off(this.namespace)
            }
        }), Pt), theme.HeaderSection = (fe = "#NavDrawer", ge = ".mobile-nav__toggle-btn", ye = ".mobile-nav__has-sublist", ve = "[data-disclosure-locale]", be = "[data-disclosure-currency]", we = "mobile-nav--expanded", xt.prototype = f.extend({}, xt.prototype, {
            cacheSelectors: function() {
                this.cache = {
                    $localeDisclosure: this.$container.find(ve),
                    $currencyDisclosure: this.$container.find(be)
                }
            },
            initDrawers: function() {
                theme.NavDrawer = new theme.Drawers("NavDrawer", "nav"), "drawer" === theme.settings.cartType && new theme.CartDrawer, this.drawerMenuButtons()
            },
            drawerMenuButtons: function() {
                f(fe).find(".js-drawer-close").on("click", function(e) {
                    e.preventDefault(), theme.NavDrawer.close()
                });
                var e = f(ge);
                e.attr("aria-expanded", "false"), e.each(function(e, t) {
                    var i = f(t);
                    i.attr("aria-controls", i.attr("data-aria-controls"))
                }), e.on("click", function() {
                    var e = f(this),
                        t = !1;
                    "true" === e.attr("aria-expanded") ? e.attr("aria-expanded", "false") : (e.attr("aria-expanded", "true"), t = !0), e.closest(ye).toggleClass(we, t)
                })
            },
            onBlockSelect: function(e) {
                theme.announcementBar.onBlockSelect(e.detail.blockId)
            },
            onDeselect: function() {
                theme.announcementBar.onBlockDeselect()
            },
            onUnload: function() {
                theme.NavDrawer.close(), theme.headerNav.unload(), theme.announcementBar.unload(), this.cache.$localeDisclosure.length && this.localeDisclosure.unload(), this.cache.$currencyDisclosure.length && this.currencyDisclosure.unload()
            }
        }), xt), theme.FooterSection = (Se = "[data-disclosure-locale]", _e = "[data-disclosure-currency]", Ot.prototype = f.extend({}, Ot.prototype, {
            cacheSelectors: function() {
                this.cache = {
                    $localeDisclosure: this.$container.find(Se),
                    $currencyDisclosure: this.$container.find(_e)
                }
            },
            onUnload: function() {
                this.cache.$localeDisclosure.length && this.localeDisclosure.unload(), this.cache.$currencyDisclosure.length && this.currencyDisclosure.unload()
            }
        }), Ot), theme.FeaturedContentSection = function() {
            f(".rte").find("a:not(:has(img))").addClass("text-link")
        }, theme.slideshows = {}, theme.SlideshowSection = (Ce = ".parallax-container", Dt.prototype = f.extend({}, Dt.prototype, {
            init: function() {
                this.onUnload();
                var e = f(this.slideshow),
                    t = {
                        autoplay: e.data("autoplay"),
                        arrows: e.data("arrows"),
                        dots: e.data("dots"),
                        fade: !0,
                        speed: 500
                    };
                theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, t)
            },
            forceReload: function() {
                this.init()
            },
            onUnload: function() {
                theme.parallaxSections[this.namespace] && (theme.parallaxSections[this.namespace].destroy(), delete theme.parallaxSections[this.namespace]), theme.slideshows[this.slideshow] && (theme.slideshows[this.slideshow].destroy(), delete theme.slideshows[this.slideshow])
            },
            onSelect: function() {
                f(this.slideshow).slick("slickPause")
            },
            onDeselect: function() {
                f(this.slideshow).slick("slickPlay")
            },
            onBlockSelect: function(e) {
                var t = f(this.slideshow),
                    i = f(".slideshow__slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                t.slick("slickGoTo", i).slick("slickPause")
            },
            onBlockDeselect: function() {
                f(this.slideshow).slick("slickPlay")
            }
        }), Dt), theme.VideoSection = (Pe = {
            byline: Ve = !(Te = {
                width: 1280,
                height: 720,
                playerVars: {
                    autohide: 0,
                    branding: 0,
                    cc_load_policy: 0,
                    controls: 0,
                    fs: 0,
                    iv_load_policy: 3,
                    modestbranding: 1,
                    playsinline: 1,
                    quality: "hd720",
                    rel: 0,
                    showinfo: 0,
                    wmode: "opaque"
                }
            }),
            title: !(Ie = []),
            portrait: !($e = []),
            loop: !0
        }, xe = {
            videoParent: ".video-parent-section",
            promoContainer: ".promo-grid__container"
        }, Oe = {
            loading: "loading",
            loaded: "loaded",
            interactable: "video-interactable"
        }, Mt.prototype = f.extend({}, Mt.prototype, {
            initYoutubeVideo: function() {
                $e[this.youtubePlayerId] = {
                    id: this.youtubePlayerId,
                    videoId: this.youtubeVideoId,
                    type: "youtube",
                    attemptedToPlay: !1,
                    events: {
                        onReady: function(e) {
                            var t, i, n, o;
                            t = e, i = this.youtubePlayerId, n = f("#" + i), o = n.attr("id"), Ie[o] = t.target, Ie[o], At(n), Ie[o].mute(), n.attr("tabindex", "-1"), Lt(o), f(window).on("scroll." + o, {
                                id: o
                            }, f.throttle(150, Lt))
                        }.bind(this),
                        onStateChange: function(e) {
                            ! function(e, t) {
                                var i = f("#" + t),
                                    n = i.attr("id"),
                                    o = Ie[n];
                                switch (e.data) {
                                    case -1:
                                        $e[n].attemptedToPlay && (Et(i), Ft(i));
                                        break;
                                    case 0:
                                        o.playVideo();
                                        break;
                                    case 1:
                                        Et(i);
                                        break;
                                    case 3:
                                        $e[n].attemptedToPlay = !0
                                }
                            }(e, this.youtubePlayerId)
                        }.bind(this)
                    }
                }, ke ? this.loadYoutubeVideo() : (theme.LibraryLoader.load("youtubeSdk"), f("body").on("youTubeReady" + this.namespace, this.loadYoutubeVideo.bind(this)))
            },
            loadYoutubeVideo: function() {
                var e = f.extend({}, Te, $e[this.youtubePlayerId]);
                e.playerVars.controls = 0, Ie[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, e), ke = !0
            },
            initVimeoVideo: function() {
                $e[this.vimeoPlayerId] = {
                    divId: this.vimeoPlayerId,
                    id: this.vimeoVideoId,
                    type: "vimeo"
                }, At(f("#" + this.vimeoPlayerId)), this.$vimeoTrigger.on("click", +this.namespace, function(e) {
                    this.requestToPlayVimeoVideo(this.vimeoPlayerId)
                }.bind(this)), Ve ? this.loadVimeoVideo() : (window.loadVimeo(), f("body").on("vimeoReady" + this.namespace, this.loadVimeoVideo.bind(this)))
            },
            loadVimeoVideo: function() {
                var e = f.extend({}, Pe, $e[this.vimeoPlayerId]);
                this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player($e[this.vimeoPlayerId].divId, e), Ve = !0, theme.config.bpSmall ? Et(f("#" + this.vimeoPlayerId)) : this.requestToPlayVimeoVideo(this.vimeoPlayerId)
            },
            requestToPlayVimeoVideo: function(e) {
                Ve ? this.playVimeoVideo(e) : f("body").on("vimeoReady" + this.namespace, function() {
                    this.playVimeoVideo(e)
                }.bind(this))
            },
            playVimeoVideo: function(e) {
                this.vimeoPlayer[e].play(), this.vimeoPlayer[e].setVolume(0), Et(f("#" + e))
            },
            onUnload: function(e) {
                var t = e.target.id.replace("shopify-section-", "");
                Ie["YouTubeVideo-" + t].destroy(), f(window).off("scroll" + this.namespace), f("body").off("vimeoReady" + this.namespace)
            }
        }), Mt), theme.BackgroundImage = (De = ".parallax-container", jt.prototype = f.extend({}, jt.prototype, {
            onUnload: function(e) {
                theme.parallaxSections[this.namespace].destroy(), delete theme.parallaxSections[this.namespace]
            }
        }), jt), theme.Testimonials = (Le = {
            accessibility: !(Me = 0),
            arrows: !1,
            dots: !0,
            autoplay: !1,
            touchThreshold: 20,
            rtl: theme.config.rtl,
            slidesToShow: 3,
            slidesToScroll: 3
        }, Bt.prototype = f.extend({}, Bt.prototype, {
            onUnload: function() {
                f(this.slider, this.wrapper).slick("unslick")
            },
            onBlockSelect: function(e) {
                var t = f(".testimonials-slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                f(this.slider, this.wrapper).slick("slickGoTo", t)
            },
            init: function(e, t) {
                this.sliderActive && (e.slick("unslick"), this.sliderActive = !1), e.slick(t), this.sliderActive = !0, AOS && AOS.refresh()
            },
            a11y: function(e, t) {
                var i = t.$list,
                    n = f(this.wrapper, this.$container);
                i.removeAttr("aria-live"), n.on("focusin", function(e) {
                    n.has(e.target).length && i.attr("aria-live", "polite")
                }), n.on("focusout", function(e) {
                    n.has(e.target).length && i.removeAttr("aria-live")
                })
            }
        }), Bt), theme.NewsletterPopup = (Rt.prototype = f.extend({}, Rt.prototype, {
            initPopupDelay: function() {
                setTimeout(function() {
                    this.modal.open()
                }.bind(this), 1e3 * this.data.secondsBeforeShow)
            },
            closePopup: function(e) {
                var t;
                this.data.testMode ? Cookies.remove(this.cookieName, {
                    path: "/"
                }) : (t = e ? 200 : this.data.daysBeforeReappear, Cookies.set(this.cookieName, "opened", {
                    path: "/",
                    expires: t
                }))
            },
            onLoad: function() {
                this.modal.open()
            },
            onSelect: function() {
                this.modal.open()
            },
            onDeselect: function() {
                this.modal.close()
            },
            onUnload: function() {}
        }), Rt), theme.Maps = (Ae = 14, Ee = null, Fe = [], je = {
            addressNoResults: theme.strings.addressNoResults,
            addressQueryLimit: theme.strings.addressQueryLimit,
            addressError: theme.strings.addressError,
            authError: theme.strings.authError
        }, Be = '[data-section-type="map"]', Re = "[data-map]", He = "[data-map-overlay]", Ue = "map-section--load-error", ze = "map-section__error errors text-center", window.gm_authFailure = function() {
            Shopify.designMode && (f(Be).addClass(Ue), f(Re).remove(), f(He).after('<div class="' + ze + '">' + theme.strings.authError + "</div>"))
        }, Ht.prototype = f.extend({}, Ht.prototype, {
            prepMapApi: function() {
                "loaded" === Ee ? this.createMap() : (Fe.push(this), "loading" !== Ee && (Ee = "loading", void 0 !== window.google && void 0 !== window.google.maps || f.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function() {
                    Ee = "loaded", f.each(Fe, function(e, t) {
                        t.createMap()
                    })
                })))
            },
            createMap: function() {
                var e, i, t, n, o = this.$map;
                return e = o, i = f.Deferred(), t = new google.maps.Geocoder, n = e.data("address-setting"), t.geocode({
                    address: n
                }, function(e, t) {
                    t !== google.maps.GeocoderStatus.OK && i.reject(t), i.resolve(e)
                }), i.then(function(e) {
                    var t = {
                            zoom: Ae,
                            backgroundColor: "none",
                            center: e[0].geometry.location,
                            draggable: !1,
                            clickableIcons: !1,
                            scrollwheel: !1,
                            disableDoubleClickZoom: !0,
                            disableDefaultUI: !0
                        },
                        i = this.map = new google.maps.Map(o[0], t),
                        n = this.center = i.getCenter();
                    new google.maps.Marker({
                        map: i,
                        position: i.getCenter()
                    }), google.maps.event.addDomListener(window, "resize", f.debounce(250, function() {
                        google.maps.event.trigger(i, "resize"), i.setCenter(n), o.removeAttr("style")
                    }))
                }.bind(this)).fail(function() {
                    var e;
                    switch (status) {
                        case "ZERO_RESULTS":
                            e = je.addressNoResults;
                            break;
                        case "OVER_QUERY_LIMIT":
                            e = je.addressQueryLimit;
                            break;
                        case "REQUEST_DENIED":
                            e = je.authError;
                            break;
                        default:
                            e = je.addressError
                    }
                    Shopify.designMode && o.parent().addClass(Ue).html('<div class="' + ze + '">' + e + "</div>")
                })
            },
            checkVisibility: function() {
                theme.isElementVisible(this.$container, 600) && (this.prepMapApi(), f(window).off(this.namespace))
            },
            onUnload: function() {
                0 !== this.$map.length && google.maps.event.clearListeners(this.map, "resize")
            }
        }), Ht), theme.Blog = (Ut.prototype = f.extend({}, Ut.prototype, {
            tagFilters: function() {
                var e = f("#BlogTagFilter");
                e.length && e.on("change", function() {
                    location.href = f(this).val()
                })
            },
            onUnload: function() {}
        }), Ut), theme.Photoswipe = (Ne = ".js-photoswipe__zoom", qe = ".photoswipe__image", Qe = ".slick-active .photoswipe__image", zt.prototype = f.extend({}, zt.prototype, {
            init: function() {
                var e = this.$container.find(Ne);
                this.$images = this.$container.find(qe);
                var i = [];
                e.on("click" + this.namespace, function(e) {
                    var t;
                    i = this.getImageData(), t = this.inSlideshow ? this.$container.find(Qe).data("index") : f(e.currentTarget).data("index"), this.initGallery(i, t)
                }.bind(this))
            },
            getImageData: function() {
                var t = [];
                return this.$images.each(function() {
                    var e = {
                        msrc: f(this).prop("currentSrc") || f(this).prop("src"),
                        src: f(this).data("photoswipe-src"),
                        w: f(this).data("photoswipe-width"),
                        h: f(this).data("photoswipe-height"),
                        el: f(this)[0],
                        initialZoomLevel: .5
                    };
                    t.push(e)
                }), t
            },
            initGallery: function(n, e) {
                var t = document.querySelectorAll(".pswp")[0],
                    i = {
                        allowPanToNext: !1,
                        captionEl: !1,
                        closeOnScroll: !1,
                        counterEl: !1,
                        history: !1,
                        index: e - 1,
                        pinchToClose: !1,
                        preloaderEl: !1,
                        scaleMode: "zoom",
                        shareEl: !1,
                        tapToToggleControls: !1,
                        getThumbBoundsFn: function(e) {
                            var t = window.pageYOffset || document.documentElement.scrollTop,
                                i = n[e].el.getBoundingClientRect();
                            return {
                                x: i.left,
                                y: i.top + t,
                                w: i.width
                            }
                        }
                    };
                this.gallery = new PhotoSwipe(t, PhotoSwipeUI_Default, n, i), this.gallery.init(), this.gallery.listen("afterChange", this.afterChange.bind(this))
            },
            afterChange: function() {
                var e, t;
                !this.inSlideshow || (e = f("#ProductPhotos-" + this.sectionId)).hasClass("slick-initialized") && (t = this.gallery.getCurrentIndex(), e.slick("slickGoTo", t))
            }
        }), zt), window.onYouTubeIframeAPIReady = function() {
            theme.config.youTubeReady = !0, f("body").trigger("youTubeReady")
        }, window.loadVimeo = function() {
            var e, t, i, n, o;
            theme.config.vimeoLoading || theme.config.vimeoReady || (theme.config.vimeoLoading = !0, (e = document.createElement("script")).src = "https://player.vimeo.com/api/player.js", (t = document.getElementsByTagName("script")[0]).parentNode.insertBefore(e, t), o = f.Deferred(), i = setInterval(function() {
                Vimeo && (clearInterval(i), clearTimeout(n), o.resolve())
            }, 500), n = setTimeout(function() {
                clearInterval(i), o.reject()
            }, 4e3), o.then(function() {
                theme.config.vimeoReady = !0, theme.config.vimeoLoading = !1, f("body").trigger("vimeoReady")
            }).fail(function() {}))
        }, theme.init = function() {
            theme.setGlobals(), theme.collapsibles.init(), theme.rte.init(), AOS.init({
                easing: "ease-out-quad",
                once: !0,
                offset: 60,
                disableMutationObserver: !0
            }), f(document.documentElement).on("keyup.tab", function(e) {
                9 === e.keyCode && (f(document.documentElement).addClass("tab-outline"), f(document.documentElement).off("keyup.tab"))
            }), f(".footer__newsletter-input").on("keyup", function() {
                f(this).addClass("footer__newsletter-input--active")
            })
        }, theme.initSecondary = function() {
            theme.initQuickShop(), theme.settings.predictiveSearch && theme.predictiveSearch.init(), theme.collectionTemplate.init(), theme.customerTemplates.init(), theme.videoModal(), document.dispatchEvent(new CustomEvent("page:loaded"))
        }, theme.setGlobals = function() {
            theme.config.hasSessionStorage = theme.isStorageSupported("session"), theme.config.hasLocalStorage = theme.isStorageSupported("local"), theme.config.hasLocalStorage && (theme.recentlyViewed.localStorage = window.localStorage.getItem("theme-recent"), theme.recentlyViewed.localStorage && (theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage))), theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage["recent-products"] ? JSON.parse(sessionStorage["recent-products"]) : {}, theme.config.isTouch && f("body").addClass("supports-touch"), enquire.register(theme.config.mediaQuerySmall, {
                match: function() {
                    theme.config.bpSmall = !0, f("body").trigger("matchSmall")
                },
                unmatch: function() {
                    theme.config.bpSmall = !1, f("body").trigger("unmatchSmall")
                }
            }), enquire.register(theme.config.mediaQuerySmallUp, {
                match: function() {
                    f("body").trigger("matchLarge")
                },
                unmatch: function() {
                    f("body").trigger("unmatchLarge")
                }
            })
        }, theme.loadImageSection = function(e) {
            function t() {
                e.removeClass("loading loading--delayed").addClass("loaded")
            }

            function i() {
                return e.find(".lazyloaded").length
            }
            var n;
            e.find("svg").length || 0 < i() ? t() : n = setInterval(function() {
                0 < i() && (clearInterval(n), t())
            }, 80)
        }, theme.isStorageSupported = function(e) {
            if (window.self !== window.top) return !1;
            var t;
            "session" === e && (t = window.sessionStorage), "local" === e && (t = window.localStorage);
            try {
                return t.setItem("test", "1"), t.removeItem("test"), !0
            } catch (e) {
                return !1
            }
        }, theme.isElementVisible = function(e, t) {
            var i = e[0].getBoundingClientRect(),
                n = window.innerHeight || document.documentElement.clientHeight;
            return t = t || 0, 0 <= i.bottom && 0 <= i.right && i.top <= n + t && i.left <= (window.innerWidth || document.documentElement.clientWidth)
        }, theme.reinitSection = function(e) {
            for (var t = 0; t < sections.instances.length; t++) {
                var i = sections.instances[t];
                i.type === e && "function" == typeof i.forceReload && i.forceReload()
            }
        }, theme.reinitProductGridItem = function(e) {
            AOS && AOS.refreshHard(), theme.initQuickShop(), window.SPR && (SPR.initDomEls(), SPR.loadBadges()), sections.register("product-template", theme.Product, e), theme.collapsibles.init()
        }, window.onpageshow = function(e) {
            e.persisted && f("body").removeClass("unloading")
        }, f(document).ready(function() {
            theme.init(), window.sections = new theme.Sections, sections.register("header-section", theme.HeaderSection), sections.register("slideshow-section", theme.SlideshowSection), sections.register("video-section", theme.VideoSection), sections.register("background-image", theme.BackgroundImage), sections.register("recently-viewed", theme.RecentlyViewed), sections.register("product", theme.Product), sections.register("product-recommendations", theme.Recommendations), sections.register("store-availability", theme.StoreAvailability), sections.register("product-template", theme.Product), sections.register("collection-header", theme.CollectionHeader), sections.register("collection-sidebar", theme.CollectionSidebar), sections.register("collection-template", theme.Collection), sections.register("featured-content-section", theme.FeaturedContentSection), sections.register("testimonials", theme.Testimonials), sections.register("newsletter-popup", theme.NewsletterPopup), sections.register("map", theme.Maps), sections.register("blog", theme.Blog), sections.register("photoswipe", theme.Photoswipe), sections.register("footer-section", theme.FooterSection), theme.initSecondary()
        }), "true" == f(".span_for_if").text() ? f(".my_msg").css("display", "block") : f(".my_msg").css("display", "none");

        function Nt() {
            var e;
            Yt.isValidNumber() ? (e = Yt.getNumber(), Qt.value = e, f(".my_form_class").unbind("submit")) : f(".my_form_class").submit(function(e) {
                e.preventDefault(), console.log("prevented"), f(".my_phone_error").css({
                    display: "block"
                })
            })
        }
        var qt = document.getElementById("my_phone_test"),
            Qt = document.getElementById("international_phone"),
            Yt = window.intlTelInput(qt, {
                separateDialCode: !0,
                initialCountry: "auto",
                geoIpLookup: function(i) {
                    f.get("https://ipinfo.io", function() {}, "jsonp").always(function(e) {
                        var t = e && e.country ? e.country : "us";
                        i(t)
                    })
                }
            });
        qt.addEventListener("change", Nt), qt.addEventListener("keyup", Nt), f(document).ready(function() {
            f(".title").click(function() {
                f(this).next().slideToggle().siblings(".content").slideUp()
            })
        }), f(window).width() <= 768 && (f(".my_frame_label").addClass("scroll-top"), console.log("less than 768px"));
        var Jt = f(".main-content").offset().top - 20;
        console.log(Jt), f(".scroll-top").click(function() {
            f("html").animate({
                scrollTop: Jt
            }, 1e3)
        })
    }(theme.jQuery);